// import React, { useState, useEffect, useRef } from 'react';
// import axios from 'axios';
// import io from 'socket.io-client';
// import {
//   Box,
//   Button,
//   Checkbox,
//   FormControlLabel,
//   List,
//   ListItem,
//   ListItemText,
//   TextField,
//   Typography,
//   Avatar,
//   CircularProgress,
//   Paper,
//   InputAdornment,
//   Divider,
//   IconButton,
// } from '@mui/material';
// import SearchIcon from '@mui/icons-material/Search';
// import SendIcon from '@mui/icons-material/Send';
// import AttachFileIcon from '@mui/icons-material/AttachFile';
// import { find, isEmpty, reverse, size } from 'lodash';
// import moment from 'moment';
// import { BiCheckDouble } from 'react-icons/bi';

// const API_BASE = `${process.env.REACT_APP_API_URL}/messages`;
// const WS_URL = window.location.origin.replace(/^http/, 'ws') + '/ws'; // Adjust if needed

// export default function ControlRoomChat() {
//   const currentUser = {
//     id: parseInt(localStorage?.getItem('user_id')),
//     user_name: localStorage?.getItem('user_name'),
//     event_id: parseInt(localStorage?.getItem('event_id')),
//   };
//   const [users, setUsers] = useState([]);
//   const [selectedUsers, setSelectedUsers] = useState([]);
//   const [messages, setMessages] = useState([]);
//   const [messageText, setMessageText] = useState('');
//   const [attachments, setAttachments] = useState([]);
//   const [previewUrls, setPreviewUrls] = useState([]);
//   const [search, setSearch] = useState('');
//   const [loading, setLoading] = useState(false);
//   const fileInputRef = useRef();
//   const chatEndRef = useRef();
//   const socketRef = useRef();
//   const isUserRole = localStorage?.getItem('roles')?.includes('USER');
//   const hasAmbulancePermission = (permission) =>
//     localStorage?.getItem('permissions').includes(permission);
//   const ambulanceTracker =
//     isUserRole && hasAmbulancePermission('AMBULANCE GPS');

//   // Fetch messages for selected users

//   const fetchMessages = async (isScroll) => {
//     if (isScroll) {
//       setLoading(true);
//     }
//     let params = { user_id: selectedUsers[0] };
//     if (selectedUsers?.length === 1) params.peer_id = selectedUsers[0];

//     try {
//       const res = await axios.get(
//         API_BASE + '/' + currentUser?.event_id + '/' + params?.user_id
//       );
//       // const res = params?.peer_id
//       //   ? await axios.get(API_BASE + '/' + params?.user_id + '/' +  params?.peer_id)
//       //   : await axios.get(API_BASE + '/' + params?.user_id);
//       setMessages(reverse(res.data));
//       if (isScroll) {
//         scrollToBottom();
//       }
//     } catch (err) {
//       console.error('Failed to fetch messages:', err);
//       // optionally show a toast / error message here
//     } finally {
//       // always runs, success or failure
//       setLoading(false);
//     }
//   };

//   // Fetch operators
//   useEffect(() => {
//     if (!ambulanceTracker) {
//       axios
//         .get(`${process.env.REACT_APP_API_URL}/messages/usersbyrole/ambulance`)
//         .then((res) => setUsers(res.data));
//     } else {
//       setSelectedUsers([parseInt(currentUser?.id)]);
//     }
//   }, [ambulanceTracker]);

//   // WebSocket setup
//   useEffect(() => {
//     if (!isEmpty(selectedUsers)) {
//       fetchMessages(true);
//     }

//     socketRef.current = io(WS_URL, { transports: ['websocket'] });

//     socketRef.current.on('connect', () => {
//       socketRef.current.emit('join', {
//         user_id: currentUser?.id,
//         role: 'control room',
//       });
//     });

//     socketRef.current.on('new_message', (msg) => {
//       if (
//         selectedUsers.length === 0 ||
//         selectedUsers.includes(msg.sender_id) ||
//         selectedUsers.includes(msg.receiver_id)
//       ) {
//         setMessages((prev) => [...prev, msg]);
//         scrollToBottom();
//       }
//     });

//     // 🔹 If ambulanceTracker is true, poll fetchMessages every 30s
//     let intervalId;
//     if (!isEmpty(selectedUsers)) {
//       intervalId = setInterval(() => {
//         fetchMessages(false);
//       }, 20000);
//     }

//     return () => {
//       socketRef.current.disconnect();
//       if (intervalId) clearInterval(intervalId);
//     };
//     // eslint-disable-next-line
//   }, [selectedUsers, ambulanceTracker]); // <-- include ambulanceTracker

//   // Scroll to bottom on new message
//   const scrollToBottom = () => {
//     setTimeout(() => {
//       if (chatEndRef.current)
//         chatEndRef.current.scrollIntoView({ behavior: 'smooth' });
//     }, 100);
//   };

//   // File selection
//   const handleFileChange = (e) => {
//     const files = Array.from(e.target.files);
//     setAttachments(files);
//     setPreviewUrls(files.map((file) => URL.createObjectURL(file)));
//   };

//   // Upload images and get URLs
//   const uploadImages = async () => {
//     const urls = [];
//     for (let file of attachments) {
//       const formData = new FormData();
//       formData.append('file', file);
//       const res = await axios.post(
//         `${process.env.REACT_APP_API_URL}/common/secureFileUpload`,
//         formData,
//         {
//           headers: { 'Content-Type': 'multipart/form-data' },
//         }
//       );
//       urls.push(
//         `${process.env.REACT_APP_IMAGE_URL}/static/images/` + res.data.filename
//       );
//     }
//     return urls;
//   };

//   // Send message (broadcast or individual)
//   const sendMessage = async () => {
//     let attachment_urls = [];
//     if (attachments.length > 0) {
//       attachment_urls = await uploadImages();
//     }
//     const payload = {
//       sender_id: parseInt(currentUser?.id),
//       receiver_id:
//         selectedUsers.length === 1 ? selectedUsers[0] : selectedUsers,
//       content: messageText,
//       attachment_urls,
//       event_id: parseInt(currentUser?.event_id),
//       timestamp: new Date().toISOString(),
//       is_read: true,
//     };
//     await axios.post(API_BASE + '/', payload);
//     setMessageText('');
//     setAttachments([]);
//     setPreviewUrls([]);
//     fileInputRef.current.value = '';
//     fetchMessages();
//     socketRef.current.emit('send_message', payload);
//   };

//   // Mark message as read
//   const markAsRead = async (msgId) => {
//     await axios.patch(`${API_BASE}/${msgId}/read`);
//     setMessages((msgs) =>
//       msgs.map((m) => (m.id === msgId ? { ...m, is_read: true } : m))
//     );
//   };

//   // UI
//   return (
//     <Paper
//       elevation={4}
//       sx={{
//         display: 'flex',
//         height: ambulanceTracker ? '85vh' : '100vh',
//         borderRadius: 3,
//         overflow: 'hidden',
//       }}
//     >
//       {/* Sidebar */}
//       {!ambulanceTracker && (
//         <Box
//           width={{ md: 300, sm: 190 }}
//           display='flex'
//           flexDirection='column'
//           bgcolor='#f7f9fc'
//           borderRight='1px solid #e0e0e0'
//         >
//           <Box p={2} pb={0}>
//             <Typography variant='h6' sx={{ fontWeight: 600 }}>
//               Operators
//             </Typography>
//             <TextField
//               size='small'
//               placeholder='Search operator'
//               value={search}
//               onChange={(e) => setSearch(e.target.value)}
//               InputProps={{
//                 startAdornment: (
//                   <InputAdornment position='start'>
//                     <SearchIcon color='action' />
//                   </InputAdornment>
//                 ),
//               }}
//               sx={{ mt: 1, mb: 1.5, width: '100%' }}
//             />
//             <FormControlLabel
//               sx={{ mb: 1 }}
//               control={
//                 <Checkbox
//                   checked={selectedUsers.length === users.length}
//                   onChange={(e) =>
//                     setSelectedUsers(
//                       e.target.checked ? users.map((u) => u.id) : []
//                     )
//                   }
//                 />
//               }
//               label='Broadcast All'
//             />
//           </Box>
//           <Divider />
//           <List dense sx={{ flex: 1, overflow: 'auto', px: 1 }}>
//             {users
//               .filter(
//                 (u) =>
//                   u.username.toLowerCase().includes(search.toLowerCase()) ||
//                   u.phone.includes(search)
//               )
//               .map((u) => (
//                 <ListItem
//                   key={u.id}
//                   disablePadding
//                   sx={{
//                     '&:hover': { bgcolor: '#eef3fb' },
//                     borderRadius: 1,
//                     px: 1,
//                   }}
//                 >
//                   <FormControlLabel
//                     sx={{ width: '100%', px: 1 }}
//                     control={
//                       <Checkbox
//                         checked={selectedUsers.includes(u.id)}
//                         onChange={(e) => {
//                           if (e.target.checked)
//                             setSelectedUsers([...selectedUsers, u.id]);
//                           else
//                             setSelectedUsers(
//                               selectedUsers.filter((id) => id !== u.id)
//                             );
//                         }}
//                       />
//                     }
//                     label={
//                       <ListItemText
//                         primaryTypographyProps={{ fontWeight: 500 }}
//                         primary={u.username}
//                         secondary={u.phone}
//                       />
//                     }
//                   />
//                 </ListItem>
//               ))}
//           </List>
//         </Box>
//       )}

//       {/* Chat Area */}
//       <Box flex={1} display='flex' flexDirection='column' bgcolor='#f9fafb'>
//         <Box
//           py={3}
//           px={1}
//           borderTop='1px solid #eee'
//           bgcolor='#fff'
//           display='flex'
//           boxShadow='0px -3px 6px rgba(0,0,0,0.2)'
//           sx={{ display: 'flex', gap: 1, alignItems: 'center' }}
//         >
//           {(!isEmpty(selectedUsers) || ambulanceTracker) && (
//             <Avatar
//               sx={{
//                 bgcolor: '#007bff', // blue background
//                 width: 32, // size
//                 height: 32,
//                 fontWeight: 600,
//                 fontSize: '1rem',
//               }}
//             >
//               {ambulanceTracker
//                 ? 'C'
//                 : size(selectedUsers) === 1
//                 ? find(users, { id: selectedUsers[0] })?.username[0]
//                 : size(selectedUsers) > 1
//                 ? 'B'
//                 : ''}
//             </Avatar>
//           )}
//           <span style={{ fontWeight: 550 }}>
//             {ambulanceTracker
//               ? 'CONTROL ROOM'
//               : size(selectedUsers) === 1
//               ? find(users, { id: selectedUsers[0] })?.username
//               : size(selectedUsers) > 1
//               ? 'BROADCAST ALL'
//               : ''}
//           </span>
//         </Box>
//         <Box flex={1} overflow='auto' p={3}>
//           {loading ? (
//             <Box display='flex' justifyContent='center' mt={5}>
//               <CircularProgress />
//             </Box>
//           ) : (
//             messages.map((msg) => (
//               <Paper
//                 key={msg.id}
//                 elevation={1}
//                 sx={{
//                   mb: 2,
//                   p: 2,
//                   width: 'fit-content',
//                   ml: msg.sender_id === currentUser?.id ? 'auto' : 0,
//                   background:
//                     msg.sender_id === currentUser?.id ? '#e8f4fd' : '#fff',
//                   borderLeft:
//                     msg.sender_id === currentUser?.id
//                       ? '4px solid #1976d2'
//                       : '4px solid #118C7E',
//                   borderRadius: 2,
//                 }}
//                 onClick={() =>
//                   !msg.is_read &&
//                   msg?.receiver_id === currentUser?.id &&
//                   markAsRead(msg?.id)
//                 }
//               >
//                 <Box display='flex' alignItems='center' mb={1}>
//                   <Avatar
//                     sx={{
//                       width: 25,
//                       height: 25,
//                       mr: 1,
//                       bgcolor:
//                         msg.sender_id !== currentUser?.id
//                           ? '#118C7E'
//                           : '#1976d2',
//                       fontSize: '0.7rem',
//                       fontWeight: 550,
//                     }}
//                   >
//                     {msg.sender_id === currentUser?.id
//                       ? currentUser?.user_name[0]?.toUpperCase()
//                       : users
//                           .find((u) => u.id === msg.sender_id)
//                           ?.username[0]?.toUpperCase() ||
//                         (ambulanceTracker &&
//                           (msg.sender_id !== currentUser?.id
//                             ? 'C'
//                             : currentUser?.user_name?.[0].toLocaleUpperCase())) ||
//                         '?'}
//                   </Avatar>
//                   <Typography
//                     variant='subtitle2'
//                     sx={{ fontWeight: 600, fontSize: '0.7rem' }}
//                   >
//                     {msg?.sender_id === currentUser?.id
//                       ? 'You'
//                       : users.find((u) => u.id === msg.sender_id)?.username ||
//                         (ambulanceTracker &&
//                           (msg.sender_id !== currentUser?.id
//                             ? 'CONTROL ROOM'
//                             : currentUser?.user_name)) ||
//                         'Operator'}
//                   </Typography>
//                   <Typography
//                     variant='caption'
//                     color='text.secondary'
//                     sx={{ ml: 2 }}
//                   >
//                     {moment().format('hh:mm A')}
//                   </Typography>
//                 </Box>
//                 {msg.content && (
//                   <Typography
//                     variant='body1'
//                     sx={{ mb: 1, whiteSpace: 'pre-wrap', fontSize: '0.7rem' }}
//                   >
//                     {msg.content}
//                   </Typography>
//                 )}
//                 <Box display='flex' flexWrap='wrap'>
//                   {Array.isArray(msg.attachment_urls) &&
//                     msg?.attachment_urls?.length > 0 &&
//                     msg?.attachment_urls?.map((url, i) => (
//                       <img
//                         key={i}
//                         src={url}
//                         alt='attachment'
//                         style={{
//                           maxWidth: 120,
//                           margin: 4,
//                           borderRadius: 8,
//                           border: '1px solid #ccc',
//                         }}
//                       />
//                     ))}
//                 </Box>
//                 {msg.is_read && (
//                   <Typography
//                     variant='caption'
//                     color='success.main'
//                     sx={{
//                       mr: 2,
//                       width: '100%',
//                       display: 'flex',
//                       justifyContent: 'flex-end',
//                     }}
//                   >
//                     <BiCheckDouble color='#4fc3f7' size={18} />
//                   </Typography>
//                 )}
//               </Paper>
//             ))
//           )}
//           <div ref={chatEndRef} />
//         </Box>

//         {/* Message Input */}
//         <Box p={2} borderTop='1px solid #eee' bgcolor='#fff' display='flex'>
//           {/* Hidden file input */}
//           <input
//             type='file'
//             multiple
//             accept='image/*'
//             ref={fileInputRef}
//             onChange={handleFileChange}
//             style={{ display: 'none' }}
//             id='chat-file-upload'
//           />

//           <TextField
//             fullWidth
//             multiline
//             minRows={2}
//             maxRows={4}
//             value={messageText}
//             onChange={(e) => setMessageText(e.target.value)}
//             placeholder='Type your message...'
//             sx={{
//               flex: 1,
//               '& .MuiOutlinedInput-root': {
//                 pr: 0, // remove default padding so icons hug the right edge
//               },
//             }}
//             InputProps={{
//               endAdornment: (
//                 <>
//                   {/* attach icon */}
//                   <InputAdornment position='end'>
//                     <label htmlFor='chat-file-upload'>
//                       <IconButton component='span' size='small' sx={{ p: 0 }}>
//                         <AttachFileIcon color='red' />
//                       </IconButton>
//                     </label>
//                   </InputAdornment>
//                   {/* send icon */}
//                   <InputAdornment position='end'>
//                     <IconButton
//                       color='primary'
//                       onClick={sendMessage}
//                       disabled={!messageText && attachments.length === 0}
//                       size='small'
//                       sx={{ p: 0, pr: 1 }}
//                     >
//                       <SendIcon />
//                     </IconButton>
//                   </InputAdornment>
//                 </>
//               ),
//             }}
//           />
//         </Box>

//         {/* Preview selected images */}
//         {previewUrls.length > 0 && (
//           <Box
//             p={2}
//             bgcolor='#f1f8e9'
//             display='flex'
//             alignItems='center'
//             flexWrap='wrap'
//           >
//             {previewUrls.map((url, i) => (
//               <Box
//                 key={i}
//                 position='relative'
//                 sx={{ display: 'inline-block', mr: 1, mb: 1 }}
//               >
//                 <img
//                   src={url}
//                   alt='preview'
//                   style={{
//                     maxWidth: 60,
//                     borderRadius: 6,
//                   }}
//                 />
//                 <IconButton
//                   size='small'
//                   sx={{
//                     position: 'absolute',
//                     top: -6,
//                     right: -6,
//                     background: 'rgba(0,0,0,0.5)',
//                     color: '#fff',
//                     p: 0.3,
//                   }}
//                   onClick={() => {
//                     // remove both from attachments & previewUrls
//                     setAttachments((prev) =>
//                       prev.filter((_, idx) => idx !== i)
//                     );
//                     setPreviewUrls((prev) =>
//                       prev.filter((_, idx) => idx !== i)
//                     );
//                   }}
//                 >
//                   ✕
//                 </IconButton>
//               </Box>
//             ))}
//           </Box>
//         )}
//       </Box>
//     </Paper>
//   );
// }

// import React, { useEffect, useState, useRef } from 'react';
// import {
//   Box,
//   Paper,
//   Avatar,
//   Typography,
//   TextField,
//   InputAdornment,
//   IconButton,
//   CircularProgress,
//   Divider,
//   List,
//   ListItem,
//   FormControlLabel,
//   Checkbox,
// } from '@mui/material';
// import SearchIcon from '@mui/icons-material/Search';
// import AttachFileIcon from '@mui/icons-material/AttachFile';
// import SendIcon from '@mui/icons-material/Send';
// import { BiCheckDouble } from 'react-icons/bi';
// import moment from 'moment';
// import axios from 'axios';
// import isEmpty from 'lodash/isEmpty';
// import reverse from 'lodash/reverse';
// import {
//   socket,
//   joinUserRoom,
//   leaveUserRoom,
//   sendMessage as sendSocketMessage,
// } from './socket'; // your socket helper
// import { uniqBy } from 'lodash';

// const API_BASE = `${process.env.REACT_APP_API_URL}/messages`;

// export default function ControlRoomChat() {
//   const currentUser = {
//     id: parseInt(localStorage?.getItem('user_id')),
//     user_name: localStorage?.getItem('user_name'),
//     event_id: parseInt(localStorage?.getItem('event_id')),
//   };

//   const [users, setUsers] = useState([]);
//   const [selectedUsers, setSelectedUsers] = useState([]);
//   const [messages, setMessages] = useState([]);
//   const [messageText, setMessageText] = useState('');
//   const [attachments, setAttachments] = useState([]);
//   const [previewUrls, setPreviewUrls] = useState([]);
//   const [search, setSearch] = useState('');
//   const [loading, setLoading] = useState(false);

//   const fileInputRef = useRef();
//   const chatEndRef = useRef();

//   const isUserRole = localStorage?.getItem('roles')?.includes('USER');
//   const hasAmbulancePermission = (permission) =>
//     localStorage?.getItem('permissions')?.includes(permission);
//   const ambulanceTracker =
//     isUserRole && hasAmbulancePermission('AMBULANCE GPS');

//   // Scroll to bottom
//   const scrollToBottom = () => {
//     setTimeout(() => {
//       chatEndRef.current?.scrollIntoView({ behavior: 'smooth' });
//     }, 100);
//   };

//   // Fetch messages
//   const fetchMessages = async () => {
//     if (isEmpty(selectedUsers)) return;
//     setLoading(true);
//     try {
//       const res = await axios.get(
//         `${API_BASE}/${currentUser.event_id}/${selectedUsers[0]}`
//       );
//       setMessages(reverse(res.data));
//       scrollToBottom();
//     } catch (err) {
//       console.error('Failed to fetch messages:', err);
//     } finally {
//       setLoading(false);
//     }
//   };

//   // Fetch operators
//   useEffect(() => {
//     if (ambulanceTracker) {
//       setSelectedUsers([58]);
//       // axios
//       //   .get(`${process.env.REACT_APP_API_URL}/messages/usersbyrole/ADMIN`)
//       //   .then((res) => setSelectedUsers([res?.data[0]?.id]));
//     } else {
//       axios
//         .get(`${process.env.REACT_APP_API_URL}/messages/usersbyrole/ambulance`)
//         .then((res) => setUsers(res.data));
//     }
//   }, [ambulanceTracker]);

//   // Socket.IO setup
//   useEffect(() => {
//     if (!isEmpty(selectedUsers)) fetchMessages();

//     // Join room
//     joinUserRoom(currentUser.id);

//     // Handle new messages
//     // const handleNewMessage = (msg) => {
//     //   if (
//     //     msg.receiver_id === currentUser.id ||
//     //     selectedUsers.includes(msg.sender_id)
//     //   ) {
//     //     setMessages((prev) => [...prev, msg]);
//     //     scrollToBottom();
//     //   }
//     // };

//     // Handle new messages
//     const handleNewMessage = (msg) => {
//       // If current user is sender or receiver
//       if (
//         msg.receiver_id === currentUser.id || // message for control room
//         msg.sender_id === currentUser.id || // message sent by control room
//         selectedUsers.includes(msg.sender_id) // message from selected user
//       ) {
//         setMessages((prev) => uniqBy([...prev, msg], 'id'));
//         scrollToBottom();
//       }

//       // Update unread counts per user
//       if (msg.receiver_id === currentUser.id) {
//         setUsers((prevUsers) =>
//           prevUsers.map((u) =>
//             u.id === msg.sender_id
//               ? { ...u, unreadCount: (u.unreadCount || 0) + 1 }
//               : u
//           )
//         );
//       }
//     };

//     // Handle message read
//     const handleMessageRead = ({ msg_id }) => {
//       setMessages((prev) =>
//         prev.map((m) => (m.id === msg_id ? { ...m, is_read: true } : m))
//       );
//     };

//     // Handle unread messages result
//     const handleUnreadMessages = (msgs) => {
//       setMessages((prev) => uniqBy([...prev, ...msgs], 'id'));
//     };

//     socket.on('new_message', handleNewMessage);
//     socket.on('message_read', handleMessageRead);
//     socket.on('get_unread_messages_result', handleUnreadMessages);

//     // Fetch unread messages on mount
//     socket.emit('get_unread_messages', { user_id: currentUser.id });

//     return () => {
//       leaveUserRoom(currentUser.id);
//       socket.off('new_message', handleNewMessage);
//       socket.off('message_read', handleMessageRead);
//       socket.off('get_unread_messages_result', handleUnreadMessages);
//     };
//     // eslint-disable-next-line
//   }, [currentUser.id, selectedUsers]);

//   // File selection
//   const handleFileChange = (e) => {
//     const files = Array.from(e.target.files);
//     setAttachments(files);
//     setPreviewUrls(files.map((file) => URL.createObjectURL(file)));
//   };

//   // Upload images
//   const uploadImages = async () => {
//     const urls = [];
//     for (let file of attachments) {
//       const formData = new FormData();
//       formData.append('file', file);
//       const res = await axios.post(
//         `${process.env.REACT_APP_API_URL}/common/secureFileUpload`,
//         formData,
//         { headers: { 'Content-Type': 'multipart/form-data' } }
//       );
//       urls.push(
//         `${process.env.REACT_APP_IMAGE_URL}/static/images/${res.data.filename}`
//       );
//     }
//     return urls;
//   };

//   // Send message
//   const sendMessage = async () => {
//     let attachment_urls = [];
//     if (attachments.length > 0) attachment_urls = await uploadImages();

//     const payload = {
//       sender_id: currentUser.id,
//       receiver_id:
//         selectedUsers.length === 1 ? selectedUsers[0] : selectedUsers,
//       content: messageText,
//       attachment_urls,
//       event_id: currentUser.event_id,
//       timestamp: new Date().toISOString(),
//       is_read: false,
//     };

//     // Save via API
//     await axios.post(API_BASE + '/', payload);

//     // Reset inputs
//     setMessageText('');
//     setAttachments([]);
//     setPreviewUrls([]);
//     fileInputRef.current.value = '';

//     // Notify via Socket.IO
//     socket.emit('send_message', payload);
//     fetchMessages();
//   };

//   // Mark as read
//   const markAsRead = (msgId, senderId) => {
//     setMessages((prev) =>
//       prev.map((m) => (m.id === msgId ? { ...m, is_read: true } : m))
//     );

//     // Reset unread count for that user
//     if (senderId) {
//       setUsers((prev) =>
//         prev.map((u) => (u.id === senderId ? { ...u, unreadCount: 0 } : u))
//       );
//     }

//     socket.emit('mark_message_read', {
//       msg_id: msgId,
//       reader_id: currentUser.id,
//     });
//   };

//   useEffect(() => {
//     if (!isEmpty(selectedUsers)) fetchMessages();

//     // Join room
//     joinUserRoom(currentUser.id);

//     // Handle new messages
//     const handleNewMessage = (msg) => {
//       if (
//         msg.receiver_id === currentUser.id ||
//         selectedUsers.includes(msg.sender_id)
//       ) {
//         setMessages((prev) => uniqBy([...prev, msg], 'id'));
//         scrollToBottom();
//       }

//       // Update unread counts per user
//       if (msg.receiver_id === currentUser.id) {
//         setUsers((prevUsers) =>
//           prevUsers.map((u) =>
//             u.id === msg.sender_id
//               ? { ...u, unreadCount: (u.unreadCount || 0) + 1 }
//               : u
//           )
//         );
//       }
//     };

//     const handleMessageRead = ({ msg_id }) => {
//       setMessages((prev) =>
//         prev.map((m) => (m.id === msg_id ? { ...m, is_read: true } : m))
//       );
//     };

//     const handleUnreadMessages = (msgs) => {
//       setMessages((prev) => uniqBy([...prev, ...msgs], 'id'));
//     };

//     socket.on('new_message', handleNewMessage);
//     socket.on('message_read', handleMessageRead);
//     socket.on('get_unread_messages_result', handleUnreadMessages);

//     // Fetch unread messages on mount
//     socket.emit('get_unread_messages', { user_id: currentUser.id });

//     return () => {
//       leaveUserRoom(currentUser.id);
//       socket.off('new_message', handleNewMessage);
//       socket.off('message_read', handleMessageRead);
//       socket.off('get_unread_messages_result', handleUnreadMessages);
//     };
//   }, [currentUser.id, selectedUsers]);

//   return (
//     <Paper
//       elevation={4}
//       sx={{
//         display: 'flex',
//         height: ambulanceTracker ? '85vh' : '100vh',
//         borderRadius: 3,
//         overflow: 'hidden',
//       }}
//     >
//       {/* Sidebar */}
//       {!ambulanceTracker && (
//         <Box
//           width={{ md: 300, sm: 190 }}
//           display='flex'
//           flexDirection='column'
//           bgcolor='#f7f9fc'
//           borderRight='1px solid #e0e0e0'
//         >
//           <Box p={2} pb={0}>
//             <Typography variant='h6' sx={{ fontWeight: 600 }}>
//               Operators
//             </Typography>
//             <TextField
//               size='small'
//               placeholder='Search operator'
//               value={search}
//               onChange={(e) => setSearch(e.target.value)}
//               InputProps={{
//                 startAdornment: (
//                   <InputAdornment position='start'>
//                     <SearchIcon color='action' />
//                   </InputAdornment>
//                 ),
//               }}
//               sx={{ mt: 1, mb: 1.5, width: '100%' }}
//             />
//             <FormControlLabel
//               sx={{ mb: 1 }}
//               control={
//                 <Checkbox
//                   checked={selectedUsers.length === users.length}
//                   onChange={(e) =>
//                     setSelectedUsers(
//                       e.target.checked ? users.map((u) => u.id) : []
//                     )
//                   }
//                 />
//               }
//               label='Broadcast All'
//             />
//           </Box>
//           <Divider />
//           <List dense sx={{ flex: 1, overflow: 'auto', px: 1 }}>
//             {users
//               ?.filter(
//                 (u) =>
//                   u.username.toLowerCase().includes(search.toLowerCase()) ||
//                   u.phone.includes(search)
//               )
//               .map((u) => (
//                 <ListItem
//                   key={u.id}
//                   disablePadding
//                   sx={{
//                     '&:hover': { bgcolor: '#eef3fb' },
//                     borderRadius: 1,
//                     px: 1,
//                   }}
//                 >
//                   <FormControlLabel
//                     sx={{ width: '100%', px: 1 }}
//                     control={
//                       <Checkbox
//                         checked={selectedUsers.includes(u.id)}
//                         onChange={(e) =>
//                           e.target.checked
//                             ? setSelectedUsers([...selectedUsers, u.id])
//                             : setSelectedUsers(
//                                 selectedUsers.filter((id) => id !== u.id)
//                               )
//                         }
//                       />
//                     }
//                     label={
//                       <Box
//                         display='flex'
//                         justifyContent='space-between'
//                         alignItems='center'
//                       >
//                         <Typography variant='body2'>
//                           {u.username} <br /> {u.phone}
//                         </Typography>
//                         {u.unreadCount > 0 && (
//                           <Box
//                             sx={{
//                               bgcolor: 'red',
//                               color: '#fff',
//                               borderRadius: '50%',
//                               width: 20,
//                               height: 20,
//                               display: 'flex',
//                               alignItems: 'center',
//                               justifyContent: 'center',
//                               fontSize: '0.7rem',
//                             }}
//                           >
//                             {u.unreadCount}
//                           </Box>
//                         )}
//                       </Box>
//                     }
//                   />
//                 </ListItem>
//               ))}
//           </List>
//         </Box>
//       )}

//       {/* Chat Area */}
//       <Box flex={1} display='flex' flexDirection='column' bgcolor='#f9fafb'>
//         {/* Header */}
//         <Box
//           py={2}
//           px={2}
//           borderBottom='1px solid #eee'
//           bgcolor='#fff'
//           display='flex'
//           alignItems='center'
//           boxShadow='0px 1px 4px rgba(0,0,0,0.1)'
//           gap={1}
//         >
//           <Avatar
//             sx={{ bgcolor: '#007bff', width: 32, height: 32, fontWeight: 600 }}
//           >
//             C
//           </Avatar>
//           <Typography variant='subtitle1' sx={{ fontWeight: 550 }}>
//             CONTROL ROOM
//           </Typography>
//         </Box>

//         {/* Messages */}
//         <Box flex={1} overflow='auto' p={2}>
//           {loading ? (
//             <Box display='flex' justifyContent='center' mt={5}>
//               <CircularProgress />
//             </Box>
//           ) : (
//             messages.map((msg) => (
//               <Paper
//                 key={msg.id}
//                 elevation={1}
//                 sx={{
//                   mb: 2,
//                   p: 1.5,
//                   width: 'fit-content',
//                   ml: msg.sender_id === currentUser.id ? 'auto' : 0,
//                   background:
//                     msg.sender_id === currentUser.id ? '#e8f4fd' : '#fff',
//                   borderLeft:
//                     msg.sender_id === currentUser.id
//                       ? '4px solid #1976d2'
//                       : '4px solid #118C7E',
//                   borderRadius: 2,
//                 }}
//                 onClick={() =>
//                   !msg.is_read &&
//                   msg.receiver_id === currentUser.id &&
//                   markAsRead(msg.id, msg.sender_id)
//                 }
//               >
//                 <Box display='flex' alignItems='center' mb={0.5}>
//                   <Avatar
//                     sx={{
//                       width: 25,
//                       height: 25,
//                       mr: 1,
//                       bgcolor:
//                         msg.sender_id !== currentUser.id
//                           ? '#118C7E'
//                           : '#1976d2',
//                       fontSize: '0.7rem',
//                       fontWeight: 550,
//                     }}
//                   >
//                     {msg.sender_id === currentUser.id
//                       ? currentUser.user_name[0].toUpperCase()
//                       : users
//                           .find((u) => u.id === msg.sender_id)
//                           ?.username[0]?.toUpperCase() || 'C'}
//                   </Avatar>
//                   <Typography variant='caption' sx={{ fontWeight: 600 }}>
//                     {msg.sender_id === currentUser.id
//                       ? 'You'
//                       : users.find((u) => u.id === msg.sender_id)?.username ||
//                         'CONTROL ROOM'}
//                   </Typography>
//                   <Typography
//                     variant='caption'
//                     color='text.secondary'
//                     sx={{ ml: 1 }}
//                   >
//                     {moment(msg.timestamp).format('hh:mm A')}
//                   </Typography>
//                 </Box>
//                 {msg.content && (
//                   <Typography
//                     variant='body2'
//                     sx={{ mb: 0.5, whiteSpace: 'pre-wrap' }}
//                   >
//                     {msg.content}
//                   </Typography>
//                 )}
//                 <Box display='flex' flexWrap='wrap'>
//                   {msg.attachment_urls?.map((url, i) => (
//                     <img
//                       key={i}
//                       src={url}
//                       alt='attachment'
//                       style={{ maxWidth: 120, margin: 4, borderRadius: 6 }}
//                     />
//                   ))}
//                 </Box>
//                 {msg.is_read && (
//                   <Box display='flex' justifyContent='flex-end'>
//                     <BiCheckDouble color='#4fc3f7' size={18} />
//                   </Box>
//                 )}
//               </Paper>
//             ))
//           )}
//           <div ref={chatEndRef} />
//         </Box>

//         {/* Message Input */}
//         <Box
//           p={2}
//           borderTop='1px solid #eee'
//           bgcolor='#fff'
//           display='flex'
//           gap={1}
//         >
//           <input
//             type='file'
//             multiple
//             accept='image/*'
//             ref={fileInputRef}
//             onChange={handleFileChange}
//             style={{ display: 'none' }}
//             id='chat-file-upload'
//           />
//           <TextField
//             fullWidth
//             multiline
//             minRows={2}
//             maxRows={4}
//             value={messageText}
//             onChange={(e) => setMessageText(e.target.value)}
//             placeholder='Type your message...'
//             InputProps={{
//               endAdornment: (
//                 <>
//                   <InputAdornment position='end'>
//                     <label htmlFor='chat-file-upload'>
//                       <IconButton component='span' size='small'>
//                         <AttachFileIcon color='error' />
//                       </IconButton>
//                     </label>
//                   </InputAdornment>
//                   <InputAdornment position='end'>
//                     <IconButton
//                       color='primary'
//                       onClick={sendMessage}
//                       disabled={!messageText && attachments.length === 0}
//                       size='small'
//                     >
//                       <SendIcon />
//                     </IconButton>
//                   </InputAdornment>
//                 </>
//               ),
//             }}
//           />
//         </Box>

//         {/* Preview attachments */}
//         {previewUrls.length > 0 && (
//           <Box p={2} display='flex' flexWrap='wrap' gap={1} bgcolor='#f1f8e9'>
//             {previewUrls.map((url, i) => (
//               <img
//                 key={i}
//                 src={url}
//                 alt='preview'
//                 style={{ maxWidth: 60, borderRadius: 6 }}
//               />
//             ))}
//           </Box>
//         )}
//       </Box>
//     </Paper>
//   );
// }

// import React, { useState, useEffect, useRef } from 'react';
// import {
//   Paper,
//   Box,
//   Typography,
//   TextField,
//   IconButton,
//   Avatar,
//   List,
//   ListItem,
//   FormControlLabel,
//   Checkbox,
//   Divider,
//   InputAdornment,
//   CircularProgress,
// } from '@mui/material';
// import {
//   Send as SendIcon,
//   AttachFile as AttachFileIcon,
//   Search as SearchIcon,
// } from '@mui/icons-material';
// import { BiCheckDouble } from 'react-icons/bi';
// import moment from 'moment';
// import { isEmpty, reverse, uniqBy } from 'lodash';

// // Import your socket functions
// import {
//   socket,
//   joinUserRoom,
//   leaveUserRoom,
//   sendMessage,
//   getAllMessages,
//   markMessageRead,
//   getUsersByRole,
//   uploadFiles,
//   setupMessageListeners,
//   removeMessageListeners
// } from './socket';

// export default function ControlRoomChat() {
//   const currentUser = {
//     id: parseInt(localStorage?.getItem('user_id')),
//     user_name: localStorage?.getItem('user_name'),
//     event_id: parseInt(localStorage?.getItem('event_id')),
//   };

//   const [users, setUsers] = useState([]);
//   const [selectedUsers, setSelectedUsers] = useState([]);
//   const [messages, setMessages] = useState([]);
//   const [messageText, setMessageText] = useState('');
//   const [attachments, setAttachments] = useState([]);
//   const [previewUrls, setPreviewUrls] = useState([]);
//   const [search, setSearch] = useState('');
//   const [loading, setLoading] = useState(false);
//   const [uploadingFiles, setUploadingFiles] = useState(false);

//   const fileInputRef = useRef();
//   const chatEndRef = useRef();

//   const isUserRole = localStorage?.getItem('roles')?.includes('USER');
//   const hasAmbulancePermission = (permission) =>
//     localStorage?.getItem('permissions')?.includes(permission);
//   const ambulanceTracker = isUserRole && hasAmbulancePermission('AMBULANCE GPS');

//   // Scroll to bottom
//   const scrollToBottom = () => {
//     setTimeout(() => {
//       chatEndRef.current?.scrollIntoView({ behavior: 'smooth' });
//     }, 100);
//   };

//   // Fetch messages using socket function
//   const fetchMessages = () => {
//     if (isEmpty(selectedUsers)) return;
//     setLoading(true);

//     getAllMessages(
//       {
//         event_id: currentUser.event_id,
//         user_id: selectedUsers[0]
//       },
//       (messages) => {
//         console.log('Fetched messages:', messages);
//         setMessages(reverse(messages));
//         setLoading(false);
//         scrollToBottom();
//       }
//     );
//   };

//   // Convert files to base64 for socket transmission
//   const convertFilesToBase64 = (files) => {
//     return Promise.all(
//       files.map((file) => {
//         return new Promise((resolve) => {
//           const reader = new FileReader();
//           reader.onload = () => {
//             resolve({
//               name: file.name,
//               type: file.type,
//               size: file.size,
//               data: reader.result.split(',')[1] // Remove data:image/jpeg;base64, prefix
//             });
//           };
//           reader.readAsDataURL(file);
//         });
//       })
//     );
//   };

//   // Send message using socket function
//   const handleSendMessage = async () => {
//     if (!messageText.trim() && attachments.length === 0) return;
//     if (selectedUsers.length === 0) return;

//     console.log("Sending message:", messageText, "attachments:", attachments.length);

//     let attachment_urls = [];

//     if (attachments.length > 0) {
//       try {
//         setUploadingFiles(true);
//         const fileData = await convertFilesToBase64(attachments);

//         // Upload files using socket function
//         uploadFiles({
//           files: fileData,
//           user_id: currentUser.id,
//           event_id: currentUser.event_id
//         }, (result) => {
//           console.log('Upload files result:', result);
//           setUploadingFiles(false);

//           if (result.success) {
//             attachment_urls = result.file_urls;

//             // Send message with attachments
//             const payload = {
//               sender_id: currentUser.id,
//               receiver_id: selectedUsers.length === 1 ? selectedUsers[0] : selectedUsers,
//               content: messageText,
//               attachment_urls,
//               event_id: currentUser.event_id,
//               timestamp: new Date().toISOString(),
//               is_read: false,
//             };

//             console.log('Sending message payload with attachments:', payload);

//             sendMessage(payload, (result) => {
//               console.log('send_message_result (with attachments):', result);
//               if (result.success) {
//                 console.log('Message with attachments sent successfully');
//               } else {
//                 console.error('Failed to send message with attachments:', result.error);
//               }
//             });

//             // Reset inputs
//             setMessageText('');
//             setAttachments([]);
//             setPreviewUrls([]);
//             if (fileInputRef.current) fileInputRef.current.value = '';

//           } else {
//             console.error('Failed to upload files:', result.error);
//           }
//         });

//         return; // Exit early since we'll send message after upload completes
//       } catch (error) {
//         setUploadingFiles(false);
//         console.error('Failed to upload files:', error);
//         return;
//       }
//     }

//     // Send text-only message
//     const payload = {
//       sender_id: currentUser.id,
//       receiver_id: selectedUsers.length === 1 ? selectedUsers[0] : selectedUsers,
//       content: messageText,
//       attachment_urls,
//       event_id: currentUser.event_id,
//       timestamp: new Date().toISOString(),
//       is_read: false,
//     };

//     console.log("Sending text-only message payload:", payload);

//     sendMessage(payload, (result) => {
//       console.log('send_message_result (text-only):', result);
//       if (result.success) {
//         console.log('Text message sent successfully');
//       } else {
//         console.error('Failed to send text message:', result.error);
//       }
//     });

//     // Reset inputs
//     setMessageText('');
//     setAttachments([]);
//     setPreviewUrls([]);
//     if (fileInputRef.current) fileInputRef.current.value = '';
//   };

//   // Mark message as read using socket function
//   const handleMarkAsRead = (msgId, senderId) => {
//     console.log('Marking message as read:', msgId, 'from sender:', senderId);

//     setMessages((prev) =>
//       prev.map((m) => (m.id === msgId ? { ...m, is_read: true } : m))
//     );

//     // Reset unread count for that user
//     if (senderId) {
//       setUsers((prev) =>
//         prev.map((u) => (u.id === senderId ? { ...u, unreadCount: 0 } : u))
//       );
//     }

//     markMessageRead(msgId, (result) => {
//       console.log('Mark message read result:', result);
//       if (result.success) {
//         console.log('Message marked as read successfully');
//       } else {
//         console.error('Failed to mark message as read:', result.error);
//       }
//     });
//   };

//   // File selection handler
//   const handleFileChange = (e) => {
//     const files = Array.from(e.target.files);
//     console.log('Files selected:', files.length);
//     setAttachments(files);

//     // Create preview URLs
//     const urls = files.map((file) => URL.createObjectURL(file));
//     setPreviewUrls(urls);
//   };

//   // Set up socket event listeners
//   useEffect(() => {
//     console.log('Setting up socket listeners for user:', currentUser.id);

//     // Join user room
//     joinUserRoom(currentUser.id);

//     // Check socket connection
//     console.log('Socket connected:', socket.connected);

//     // Define event handlers
//     const handleNewMessage = (msg) => {
//       console.log("Received new_message event:", msg);

//       if (
//         msg.receiver_id === currentUser.id ||
//         msg.sender_id === currentUser.id ||
//         selectedUsers.includes(msg.sender_id) ||
//         (Array.isArray(msg.receiver_id) && msg.receiver_id.includes(currentUser.id))
//       ) {
//         setMessages((prev) => {
//           const updatedMessages = uniqBy([...prev, msg], 'id');
//           console.log('Updated messages list:', updatedMessages.length);
//           return updatedMessages;
//         });
//         scrollToBottom();
//       }

//       // Update unread counts
//       if (msg.receiver_id === currentUser.id && msg.sender_id !== currentUser.id) {
//         setUsers((prevUsers) =>
//           prevUsers.map((u) =>
//             u.id === msg.sender_id
//               ? { ...u, unreadCount: (u.unreadCount || 0) + 1 }
//               : u
//           )
//         );
//       }
//     };

//     const handleMessageRead = ({ msg_id }) => {
//       console.log("Received message_read event for message:", msg_id);
//       setMessages((prev) =>
//         prev.map((m) => (m.id === msg_id ? { ...m, is_read: true } : m))
//       );
//     };

//     // Set up event listeners using the socket functions
//     setupMessageListeners({
//       onNewMessage: handleNewMessage,
//       onMessageRead: handleMessageRead
//     });

//     // Cleanup function
//     return () => {
//       console.log('Cleaning up socket listeners for user:', currentUser.id);
//       leaveUserRoom(currentUser.id);
//       removeMessageListeners({
//         onNewMessage: handleNewMessage,
//         onMessageRead: handleMessageRead
//       });
//     };
//   }, [currentUser.id, selectedUsers]);

//   // Fetch users when component mounts
//   useEffect(() => {
//     console.log('Fetching users, ambulanceTracker:', ambulanceTracker);

//     if (ambulanceTracker) {
//       setSelectedUsers([58]);
//     } else {
//       getUsersByRole('ambulance', (users) => {
//         console.log('Fetched users:', users);
//         setUsers(users.map(user => ({ ...user, unreadCount: 0 })));
//       });
//     }
//   }, [ambulanceTracker]);

//   // Fetch messages when selected users change
//   useEffect(() => {
//     console.log('Selected users changed:', selectedUsers);
//     if (!isEmpty(selectedUsers)) {
//       fetchMessages();
//     }
//   }, [selectedUsers]);

//   return (
//     <Paper
//       elevation={4}
//       sx={{
//         display: 'flex',
//         height: ambulanceTracker ? '85vh' : '100vh',
//         borderRadius: 3,
//         overflow: 'hidden',
//       }}
//     >
//       {/* Sidebar */}
//       {!ambulanceTracker && (
//         <Box
//           width={{ md: 300, sm: 190 }}
//           display='flex'
//           flexDirection='column'
//           bgcolor='#f7f9fc'
//           borderRight='1px solid #e0e0e0'
//         >
//           <Box p={2} pb={0}>
//             <Typography variant='h6' sx={{ fontWeight: 600 }}>
//               Operators
//             </Typography>
//             <TextField
//               size='small'
//               placeholder='Search operator'
//               value={search}
//               onChange={(e) => setSearch(e.target.value)}
//               InputProps={{
//                 startAdornment: (
//                   <InputAdornment position='start'>
//                     <SearchIcon color='action' />
//                   </InputAdornment>
//                 ),
//               }}
//               sx={{ mt: 1, mb: 1.5, width: '100%' }}
//             />
//             <FormControlLabel
//               sx={{ mb: 1 }}
//               control={
//                 <Checkbox
//                   checked={selectedUsers.length === users.length}
//                   onChange={(e) =>
//                     setSelectedUsers(
//                       e.target.checked ? users.map((u) => u.id) : []
//                     )
//                   }
//                 />
//               }
//               label='Broadcast All'
//             />
//           </Box>
//           <Divider />
//           <List dense sx={{ flex: 1, overflow: 'auto', px: 1 }}>
//             {users
//               ?.filter(
//                 (u) =>
//                   u.username?.toLowerCase().includes(search.toLowerCase()) ||
//                   u.phone?.includes(search)
//               )
//               .map((u) => (
//                 <ListItem
//                   key={u.id}
//                   disablePadding
//                   sx={{
//                     '&:hover': { bgcolor: '#eef3fb' },
//                     borderRadius: 1,
//                     px: 1,
//                   }}
//                 >
//                   <FormControlLabel
//                     sx={{ width: '100%', px: 1 }}
//                     control={
//                       <Checkbox
//                         checked={selectedUsers.includes(u.id)}
//                         onChange={(e) =>
//                           e.target.checked
//                             ? setSelectedUsers([...selectedUsers, u.id])
//                             : setSelectedUsers(
//                                 selectedUsers.filter((id) => id !== u.id)
//                               )
//                         }
//                       />
//                     }
//                     label={
//                       <Box
//                         display='flex'
//                         justifyContent='space-between'
//                         alignItems='center'
//                       >
//                         <Typography variant='body2'>
//                           {u.username} <br /> {u.phone}
//                         </Typography>
//                         {u.unreadCount > 0 && (
//                           <Box
//                             sx={{
//                               bgcolor: 'red',
//                               color: '#fff',
//                               borderRadius: '50%',
//                               width: 20,
//                               height: 20,
//                               display: 'flex',
//                               alignItems: 'center',
//                               justifyContent: 'center',
//                               fontSize: '0.7rem',
//                             }}
//                           >
//                             {u.unreadCount}
//                           </Box>
//                         )}
//                       </Box>
//                     }
//                   />
//                 </ListItem>
//               ))}
//           </List>
//         </Box>
//       )}

//       {/* Chat Area */}
//       <Box flex={1} display='flex' flexDirection='column' bgcolor='#f9fafb'>
//         {/* Header */}
//         <Box
//           py={2}
//           px={2}
//           borderBottom='1px solid #eee'
//           bgcolor='#fff'
//           display='flex'
//           alignItems='center'
//           boxShadow='0px 1px 4px rgba(0,0,0,0.1)'
//           gap={1}
//         >
//           <Avatar
//             sx={{ bgcolor: '#007bff', width: 32, height: 32, fontWeight: 600 }}
//           >
//             C
//           </Avatar>
//           <Typography variant='subtitle1' sx={{ fontWeight: 550 }}>
//             CONTROL ROOM
//           </Typography>
//           {!socket.connected && (
//             <Typography variant='caption' color='error' sx={{ ml: 'auto' }}>
//               Disconnected
//             </Typography>
//           )}
//           {socket.connected && (
//             <Typography variant='caption' color='success.main' sx={{ ml: 'auto' }}>
//               Connected
//             </Typography>
//           )}
//         </Box>

//         {/* Messages */}
//         <Box flex={1} overflow='auto' p={2}>
//           {loading ? (
//             <Box display='flex' justifyContent='center' mt={5}>
//               <CircularProgress />
//             </Box>
//           ) : (
//             messages.map((msg) => (
//               <Paper
//                 key={msg.id}
//                 elevation={1}
//                 sx={{
//                   mb: 2,
//                   p: 1.5,
//                   width: 'fit-content',
//                   ml: msg.sender_id === currentUser.id ? 'auto' : 0,
//                   background:
//                     msg.sender_id === currentUser.id ? '#e8f4fd' : '#fff',
//                   borderLeft:
//                     msg.sender_id === currentUser.id
//                       ? '4px solid #1976d2'
//                       : '4px solid #118C7E',
//                   borderRadius: 2,
//                   cursor: !msg.is_read && msg.receiver_id === currentUser.id ? 'pointer' : 'default'
//                 }}
//                 onClick={() =>
//                   !msg.is_read &&
//                   msg.receiver_id === currentUser.id &&
//                   handleMarkAsRead(msg.id, msg.sender_id)
//                 }
//               >
//                 <Box display='flex' alignItems='center' mb={0.5}>
//                   <Avatar
//                     sx={{
//                       width: 25,
//                       height: 25,
//                       mr: 1,
//                       bgcolor:
//                         msg.sender_id !== currentUser.id
//                           ? '#118C7E'
//                           : '#1976d2',
//                       fontSize: '0.7rem',
//                       fontWeight: 550,
//                     }}
//                   >
//                     {msg.sender_id === currentUser.id
//                       ? currentUser.user_name?.[0]?.toUpperCase()
//                       : users
//                           .find((u) => u.id === msg.sender_id)
//                           ?.username?.[0]?.toUpperCase() || 'U'}
//                   </Avatar>
//                   <Typography variant='caption' sx={{ fontWeight: 600 }}>
//                     {msg.sender_id === currentUser.id
//                       ? 'You'
//                       : users.find((u) => u.id === msg.sender_id)?.username ||
//                         'Unknown User'}
//                   </Typography>
//                   <Typography
//                     variant='caption'
//                     color='text.secondary'
//                     sx={{ ml: 1 }}
//                   >
//                     {moment(msg.timestamp).format('hh:mm A')}
//                   </Typography>
//                 </Box>
//                 {msg.content && (
//                   <Typography
//                     variant='body2'
//                     sx={{ mb: 0.5, whiteSpace: 'pre-wrap' }}
//                   >
//                     {msg.content}
//                   </Typography>
//                 )}
//                 <Box display='flex' flexWrap='wrap'>
//                   {msg.attachment_urls?.map((url, i) => (
//                     <img
//                       key={i}
//                       src={url}
//                       alt='attachment'
//                       style={{
//                         maxWidth: 120,
//                         margin: 4,
//                         borderRadius: 6,
//                         cursor: 'pointer'
//                       }}
//                       onClick={() => window.open(url, '_blank')}
//                     />
//                   ))}
//                 </Box>
//                 {msg.is_read && msg.sender_id === currentUser.id && (
//                   <Box display='flex' justifyContent='flex-end'>
//                     <BiCheckDouble color='#4fc3f7' size={18} />
//                   </Box>
//                 )}
//               </Paper>
//             ))
//           )}
//           <div ref={chatEndRef} />
//         </Box>

//         {/* Message Input */}
//         <Box
//           p={2}
//           borderTop='1px solid #eee'
//           bgcolor='#fff'
//           display='flex'
//           gap={1}
//         >
//           <input
//             type='file'
//             multiple
//             accept='image/*'
//             ref={fileInputRef}
//             onChange={handleFileChange}
//             style={{ display: 'none' }}
//             id='chat-file-upload'
//           />
//           <TextField
//             fullWidth
//             multiline
//             minRows={2}
//             maxRows={4}
//             value={messageText}
//             onChange={(e) => setMessageText(e.target.value)}
//             placeholder='Type your message...'
//             disabled={uploadingFiles || !socket.connected}
//             onKeyDown={(e) => {
//               if (e.key === 'Enter' && !e.shiftKey) {
//                 e.preventDefault();
//                 handleSendMessage();
//               }
//             }}
//             InputProps={{
//               endAdornment: (
//                 <>
//                   <InputAdornment position='end'>
//                     <label htmlFor='chat-file-upload'>
//                       <IconButton
//                         component='span'
//                         size='small'
//                         disabled={uploadingFiles || !socket.connected}
//                       >
//                         <AttachFileIcon
//                           color={uploadingFiles || !socket.connected ? 'disabled' : 'primary'}
//                         />
//                       </IconButton>
//                     </label>
//                   </InputAdornment>
//                   <InputAdornment position='end'>
//                     <IconButton
//                       color='primary'
//                       onClick={handleSendMessage}
//                       disabled={
//                         (!messageText.trim() && attachments.length === 0) ||
//                         uploadingFiles ||
//                         !socket.connected ||
//                         selectedUsers.length === 0
//                       }
//                       size='small'
//                     >
//                       {uploadingFiles ? (
//                         <CircularProgress size={20} />
//                       ) : (
//                         <SendIcon />
//                       )}
//                     </IconButton>
//                   </InputAdornment>
//                 </>
//               ),
//             }}
//           />
//         </Box>

//         {/* Preview attachments */}
//         {previewUrls.length > 0 && (
//           <Box p={2} display='flex' flexWrap='wrap' gap={1} bgcolor='#f1f8e9'>
//             <Typography variant='caption' sx={{ width: '100%', mb: 1 }}>
//               Attachments ({previewUrls.length}):
//             </Typography>
//             {previewUrls.map((url, i) => (
//               <Box key={i} position='relative'>
//                 <img
//                   src={url}
//                   alt='preview'
//                   style={{ maxWidth: 60, borderRadius: 6 }}
//                 />
//                 <IconButton
//                   size='small'
//                   sx={{
//                     position: 'absolute',
//                     top: -8,
//                     right: -8,
//                     bgcolor: 'error.main',
//                     color: 'white',
//                     width: 20,
//                     height: 20,
//                     '&:hover': { bgcolor: 'error.dark' }
//                   }}
//                   onClick={() => {
//                     const newAttachments = attachments.filter((_, index) => index !== i);
//                     const newPreviewUrls = previewUrls.filter((_, index) => index !== i);
//                     setAttachments(newAttachments);
//                     setPreviewUrls(newPreviewUrls);
//                   }}
//                 >
//                   ×
//                 </IconButton>
//               </Box>
//             ))}
//           </Box>
//         )}
//       </Box>
//     </Paper>
//   );
// }

// import React, { useState, useEffect, useRef } from 'react';
// import { io } from 'socket.io-client';
// import {
//   Paper,
//   Box,
//   Typography,
//   TextField,
//   IconButton,
//   Avatar,
//   List,
//   ListItem,
//   FormControlLabel,
//   Checkbox,
//   Divider,
//   InputAdornment,
//   CircularProgress,
// } from '@mui/material';
// import {
//   Send as SendIcon,
//   AttachFile as AttachFileIcon,
//   Search as SearchIcon,
// } from '@mui/icons-material';
// import { BiCheckDouble } from 'react-icons/bi';
// import moment from 'moment';
// import { isEmpty, reverse, uniqBy } from 'lodash';

// const WS_URL = 'wss://procam.pythonanywhere.com/';

// export default function ControlRoomChat() {
//   const currentUser = {
//     id: parseInt(localStorage?.getItem('user_id')),
//     user_name: localStorage?.getItem('user_name'),
//     event_id: parseInt(localStorage?.getItem('event_id')),
//   };

//   const [users, setUsers] = useState([]);
//   const [selectedUsers, setSelectedUsers] = useState([]);
//   const [messages, setMessages] = useState([]);
//   const [messageText, setMessageText] = useState('');
//   const [attachments, setAttachments] = useState([]);
//   const [previewUrls, setPreviewUrls] = useState([]);
//   const [search, setSearch] = useState('');
//   const [loading, setLoading] = useState(false);
//   const [uploadingFiles, setUploadingFiles] = useState(false);
//   const [connected, setConnected] = useState(false);

//   const fileInputRef = useRef();
//   const chatEndRef = useRef();
//   const socketRef = useRef();

//   const isUserRole = localStorage?.getItem('roles')?.includes('USER');
//   const hasAmbulancePermission = (permission) =>
//     localStorage?.getItem('permissions')?.includes(permission);
//   const ambulanceTracker =
//     isUserRole && hasAmbulancePermission('AMBULANCE GPS');

//   // Scroll to bottom
//   const scrollToBottom = () => {
//     setTimeout(() => {
//       chatEndRef.current?.scrollIntoView({ behavior: 'smooth' });
//     }, 100);
//   };

//   // Convert files to base64 for socket transmission
//   const convertFilesToBase64 = (files) => {
//     return Promise.all(
//       files.map((file) => {
//         return new Promise((resolve) => {
//           const reader = new FileReader();
//           reader.onload = () => {
//             resolve({
//               name: file.name,
//               type: file.type,
//               size: file.size,
//               data: reader.result.split(',')[1],
//             });
//           };
//           reader.readAsDataURL(file);
//         });
//       })
//     );
//   };
//   const handleSendMessage = async (e) => {
//     if (e) e.preventDefault();
//     if (!messageText.trim() && attachments.length === 0) return;
//     if (selectedUsers.length === 0) return;
//     if (!socketRef.current || !connected) return;

//     console.log(
//       'Sending message:',
//       messageText,
//       'attachments:',
//       attachments.length
//     );

//     let attachment_urls = [];

//     if (attachments.length > 0) {
//       try {
//         setUploadingFiles(true);
//         const fileData = await convertFilesToBase64(attachments);

//         // Upload files first
//         socketRef.current.emit('upload_files', {
//           files: fileData,
//           user_id: currentUser.id,
//           event_id: currentUser.event_id,
//         });

//         // Wait for upload response before sending message
//         return;
//       } catch (error) {
//         setUploadingFiles(false);
//         console.error('Failed to convert files:', error);
//         return;
//       }
//     }

//     // Create optimistic message immediately
//     const tempId = `temp-${Date.now()}-${Math.random()}`;
//     const optimisticMessage = {
//       id: tempId,
//       sender_id: currentUser.id,
//       receiver_id: selectedUsers[0],
//       receiver_ids:
//         selectedUsers.length === 1 ? [selectedUsers[0]] : selectedUsers,
//       content: messageText,
//       attachment_urls,
//       event_id: currentUser.event_id,
//       timestamp: new Date().toISOString(),
//       is_read: false,
//       status: 'sending', // Add status for UI feedback
//     };

//     // Add message to state immediately (optimistic update)
//     setMessages((prevMessages) => {
//       const updatedMessages = uniqBy(
//         [...prevMessages, optimisticMessage],
//         'id'
//       );
//       return updatedMessages;
//     });

//     // Send message
//     const payload = {
//       sender_id: currentUser.id,
//       receiver_ids:
//         selectedUsers.length === 1 ? [selectedUsers[0]] : selectedUsers,
//       content: messageText,
//       attachment_urls,
//       event_id: currentUser.event_id,
//       timestamp: new Date().toISOString(),
//       is_read: false,
//       tempId: tempId, // Include temp ID for tracking
//     };

//     console.log('Sending message payload:', payload);
//     socketRef.current.emit('send_message', payload);

//     // Clear inputs immediately for better UX
//     setMessageText('');
//     setAttachments([]);
//     setPreviewUrls([]);
//     if (fileInputRef.current) fileInputRef.current.value = '';
//     scrollToBottom();
//   };

//   useEffect(() => {
//     const socket = io(WS_URL, {
//       transports: ['websocket'],
//     });

//     socketRef.current = socket;

//     socket.on('connect', () => {
//       console.log('Socket connected');
//       setConnected(true);

//       // Join user room
//       socket.emit('join', { user_id: currentUser.id });

//       // Get all messages if users are selected
//       if (!isEmpty(selectedUsers)) {
//         socket.emit('get_all_messages', {
//           event_id: currentUser.event_id,
//           user_id: selectedUsers[0],
//         });
//       }

//       // Get users by role if not ambulance tracker
//       if (!ambulanceTracker) {
//         socket.emit('get_users_by_role', { role: 'ambulance' });
//       }
//     });

//     socket.on('disconnect', () => {
//       console.log('Socket disconnected');
//       setConnected(false);
//     });

//     // Handle get all messages result
//     socket.on('get_all_messages_result', (msgs) => {
//       console.log('Fetched messages:', msgs);
//       setMessages(reverse(msgs));
//       setLoading(false);
//       scrollToBottom();
//     });

//     // Handle send message result - UPDATED
//     socket.on('send_message_result', (result) => {
//       console.log('Send message result:', result);

//       if (result.success) {
//         setMessages((prevMessages) =>
//           prevMessages.map((msg) =>
//             msg.status === 'sending'
//               ? { ...msg, status: 'sent', id: result.message_id || msg.id }
//               : msg
//           )
//         );
//       } else {
//         console.error('Failed to send message:', result.error);

//         // Remove failed message or mark as failed
//         setMessages((prevMessages) =>
//           prevMessages.map((msg) =>
//             msg.status === 'sending' ? { ...msg, status: 'failed' } : msg
//           )
//         );
//       }
//     });

//     // Handle new incoming messages
//     socket.on('new_message', (msg) => {
//       console.log('Received new message:', msg);

//       if (
//         msg.receiver_id === currentUser.id ||
//         msg.sender_id === currentUser.id ||
//         selectedUsers.includes(msg.sender_id) ||
//         (Array.isArray(msg.receiver_id) &&
//           msg.receiver_id.includes(currentUser.id))
//       ) {
//         setMessages((prev) => {
//           // Don't add if it's our own message that we already have optimistically
//           const isDuplicate = prev.some(
//             (existingMsg) =>
//               existingMsg.sender_id === msg.sender_id &&
//               existingMsg.content === msg.content &&
//               existingMsg.timestamp === msg.timestamp
//           );

//           if (!isDuplicate) {
//             const updatedMessages = uniqBy([...prev, msg], 'id');
//             console.log('Updated messages list:', updatedMessages.length);
//             return updatedMessages;
//           }
//           return prev;
//         });
//         scrollToBottom();
//       }

//       // Update unread counts
//       if (
//         msg.receiver_id === currentUser.id &&
//         msg.sender_id !== currentUser.id
//       ) {
//         setUsers((prevUsers) =>
//           prevUsers.map((u) =>
//             u.id === msg.sender_id
//               ? { ...u, unreadCount: (u.unreadCount || 0) + 1 }
//               : u
//           )
//         );
//       }
//     });

//     // Handle message read event
//     socket.on('message_read', ({ msg_id }) => {
//       console.log('Message marked as read:', msg_id);
//       setMessages((prev) =>
//         prev.map((m) => (m.id === msg_id ? { ...m, is_read: true } : m))
//       );
//     });

//     // Handle get users by role result
//     socket.on('get_users_by_role_result', (users) => {
//       console.log('Fetched users:', users);
//       setUsers(users.map((user) => ({ ...user, unreadCount: 0 })));
//     });

//     // Handle file upload result - UPDATED
//     socket.on('upload_files_result', (result) => {
//       console.log('Upload files result:', result);
//       setUploadingFiles(false);

//       if (result.success) {
//         // Create optimistic message with attachments
//         const tempId = `temp-${Date.now()}-${Math.random()}`;
//         const optimisticMessage = {
//           id: tempId,
//           sender_id: currentUser.id,
//           receiver_id: selectedUsers[0],
//           receiver_ids:
//             selectedUsers.length === 1 ? [selectedUsers[0]] : selectedUsers,
//           content: messageText,
//           attachment_urls: result.file_urls,
//           event_id: currentUser.event_id,
//           timestamp: new Date().toISOString(),
//           is_read: false,
//           status: 'sending',
//         };

//         // Add message optimistically
//         setMessages((prevMessages) => {
//           const updatedMessages = uniqBy(
//             [...prevMessages, optimisticMessage],
//             'id'
//           );
//           return updatedMessages;
//         });

//         // Send message with attachments
//         const payload = {
//           sender_id: currentUser.id,
//           receiver_ids:
//             selectedUsers.length === 1 ? [selectedUsers[0]] : selectedUsers,
//           content: messageText,
//           attachment_urls: result.file_urls,
//           event_id: currentUser.event_id,
//           timestamp: new Date().toISOString(),
//           is_read: false,
//           tempId: tempId,
//         };

//         console.log('Sending message with attachments:', payload);
//         socketRef.current.emit('send_message', payload);

//         // Clear inputs
//         setMessageText('');
//         setAttachments([]);
//         setPreviewUrls([]);
//         if (fileInputRef.current) fileInputRef.current.value = '';
//         scrollToBottom();
//       } else {
//         console.error('Failed to upload files:', result.error);
//       }
//     });

//     return () => {
//       socket.disconnect();
//     };
//   }, [currentUser.id, currentUser.event_id]);

//   // Mark message as read
//   const handleMarkAsRead = (msgId, senderId) => {
//     console.log('Marking message as read:', msgId, 'from sender:', senderId);

//     setMessages((prev) =>
//       prev.map((m) => (m.id === msgId ? { ...m, is_read: true } : m))
//     );

//     if (senderId) {
//       setUsers((prev) =>
//         prev.map((u) => (u.id === senderId ? { ...u, unreadCount: 0 } : u))
//       );
//     }

//     if (socketRef.current) {
//       socketRef.current.emit('mark_message_read', { message_id: msgId });
//     }
//   };

//   // File selection handler
//   const handleFileChange = (e) => {
//     const files = Array.from(e.target.files);
//     console.log('Files selected:', files.length);
//     setAttachments(files);

//     const urls = files.map((file) => URL.createObjectURL(file));
//     setPreviewUrls(urls);
//   };

//   // Handle ambulance tracker setup
//   useEffect(() => {
//     if (ambulanceTracker) {
//       setSelectedUsers([58]);
//     }
//   }, [ambulanceTracker]);

//   // Fetch messages when selected users change
//   useEffect(() => {
//     if (!isEmpty(selectedUsers) && socketRef.current && connected) {
//       setLoading(true);
//       socketRef.current.emit('get_all_messages', {
//         event_id: currentUser.event_id,
//         user_id: selectedUsers[0],
//       });
//     }
//   }, [selectedUsers, connected]);

//   return (
//     <Paper
//       elevation={4}
//       sx={{
//         display: 'flex',
//         height: ambulanceTracker ? '85vh' : '100vh',
//         borderRadius: 3,
//         overflow: 'hidden',
//       }}
//     >
//       {/* Sidebar */}
//       {!ambulanceTracker && (
//         <Box
//           width={{ md: 300, sm: 190 }}
//           display='flex'
//           flexDirection='column'
//           bgcolor='#f7f9fc'
//           borderRight='1px solid #e0e0e0'
//         >
//           <Box p={2} pb={0}>
//             <Typography variant='h6' sx={{ fontWeight: 600 }}>
//               Operators
//             </Typography>
//             <TextField
//               size='small'
//               placeholder='Search operator'
//               value={search}
//               onChange={(e) => setSearch(e.target.value)}
//               InputProps={{
//                 startAdornment: (
//                   <InputAdornment position='start'>
//                     <SearchIcon color='action' />
//                   </InputAdornment>
//                 ),
//               }}
//               sx={{ mt: 1, mb: 1.5, width: '100%' }}
//             />
//             <FormControlLabel
//               sx={{ mb: 1 }}
//               control={
//                 <Checkbox
//                   checked={selectedUsers.length === users.length}
//                   onChange={(e) =>
//                     setSelectedUsers(
//                       e.target.checked ? users.map((u) => u.id) : []
//                     )
//                   }
//                 />
//               }
//               label='Broadcast All'
//             />
//           </Box>
//           <Divider />
//           <List dense sx={{ flex: 1, overflow: 'auto', px: 1 }}>
//             {users
//               ?.filter(
//                 (u) =>
//                   u.username?.toLowerCase().includes(search.toLowerCase()) ||
//                   u.phone?.includes(search)
//               )
//               .map((u) => (
//                 <ListItem
//                   key={u.id}
//                   disablePadding
//                   sx={{
//                     '&:hover': { bgcolor: '#eef3fb' },
//                     borderRadius: 1,
//                     px: 1,
//                   }}
//                 >
//                   <FormControlLabel
//                     sx={{ width: '100%', px: 1 }}
//                     control={
//                       <Checkbox
//                         checked={selectedUsers.includes(u.id)}
//                         onChange={(e) =>
//                           e.target.checked
//                             ? setSelectedUsers([...selectedUsers, u.id])
//                             : setSelectedUsers(
//                                 selectedUsers.filter((id) => id !== u.id)
//                               )
//                         }
//                       />
//                     }
//                     label={
//                       <Box
//                         display='flex'
//                         justifyContent='space-between'
//                         alignItems='center'
//                       >
//                         <Typography variant='body2'>
//                           {u.username} <br /> {u.phone}
//                         </Typography>
//                         {u.unreadCount > 0 && (
//                           <Box
//                             sx={{
//                               bgcolor: 'red',
//                               color: '#fff',
//                               borderRadius: '50%',
//                               width: 20,
//                               height: 20,
//                               display: 'flex',
//                               alignItems: 'center',
//                               justifyContent: 'center',
//                               fontSize: '0.7rem',
//                             }}
//                           >
//                             {u.unreadCount}
//                           </Box>
//                         )}
//                       </Box>
//                     }
//                   />
//                 </ListItem>
//               ))}
//           </List>
//         </Box>
//       )}

//       {/* Chat Area */}
//       <Box flex={1} display='flex' flexDirection='column' bgcolor='#f9fafb'>
//         {/* Header */}
//         <Box
//           py={2}
//           px={2}
//           borderBottom='1px solid #eee'
//           bgcolor='#fff'
//           display='flex'
//           alignItems='center'
//           boxShadow='0px 1px 4px rgba(0,0,0,0.1)'
//           gap={1}
//         >
//           <Avatar
//             sx={{ bgcolor: '#007bff', width: 32, height: 32, fontWeight: 600 }}
//           >
//             C
//           </Avatar>
//           <Typography variant='subtitle1' sx={{ fontWeight: 550 }}>
//             CONTROL ROOM
//           </Typography>
//           {!connected && (
//             <Typography variant='caption' color='error' sx={{ ml: 'auto' }}>
//               Disconnected
//             </Typography>
//           )}
//           {connected && (
//             <Typography
//               variant='caption'
//               color='success.main'
//               sx={{ ml: 'auto' }}
//             >
//               Connected
//             </Typography>
//           )}
//         </Box>

//         {/* Messages */}
//         <Box flex={1} overflow='auto' p={2}>
//           {loading ? (
//             <Box display='flex' justifyContent='center' mt={5}>
//               <CircularProgress />
//             </Box>
//           ) : (
//             messages.map((msg) => (
//               <Paper
//                 key={msg.id}
//                 elevation={1}
//                 sx={{
//                   mb: 2,
//                   p: 1.5,
//                   width: 'fit-content',
//                   ml: msg.sender_id === currentUser.id ? 'auto' : 0,
//                   background:
//                     msg.sender_id === currentUser.id ? '#e8f4fd' : '#fff',
//                   borderLeft:
//                     msg.sender_id === currentUser.id
//                       ? '4px solid #1976d2'
//                       : '4px solid #118C7E',
//                   borderRadius: 2,
//                   cursor:
//                     !msg.is_read && msg.receiver_id === currentUser.id
//                       ? 'pointer'
//                       : 'default',
//                 }}
//                 onClick={() =>
//                   !msg.is_read &&
//                   msg.receiver_id === currentUser.id &&
//                   handleMarkAsRead(msg.id, msg.sender_id)
//                 }
//               >
//                 <Box display='flex' alignItems='center' mb={0.5}>
//                   <Avatar
//                     sx={{
//                       width: 25,
//                       height: 25,
//                       mr: 1,
//                       bgcolor:
//                         msg.sender_id !== currentUser.id
//                           ? '#118C7E'
//                           : '#1976d2',
//                       fontSize: '0.7rem',
//                       fontWeight: 550,
//                     }}
//                   >
//                     {msg.sender_id === currentUser.id
//                       ? currentUser.user_name?.[0]?.toUpperCase()
//                       : users
//                           .find((u) => u.id === msg.sender_id)
//                           ?.username?.[0]?.toUpperCase() || 'U'}
//                   </Avatar>
//                   <Typography variant='caption' sx={{ fontWeight: 600 }}>
//                      {msg.sender_id === currentUser.id
//                       ? 'You'
//                       : users.find((u) => u.id === msg.sender_id)?.username ||
//                         'CONTROL ROOM'}
//                   </Typography>
//                   <Typography
//                     variant='caption'
//                     color='text.secondary'
//                     sx={{ ml: 1 }}
//                   >
//                     {moment(msg.timestamp).format('hh:mm A')}
//                   </Typography>
//                 </Box>
//                 {msg.content && (
//                   <Typography
//                     variant='body2'
//                     sx={{ mb: 0.5, whiteSpace: 'pre-wrap' }}
//                   >
//                     {msg.content}
//                   </Typography>
//                 )}
//                 <Box display='flex' flexWrap='wrap'>
//                   {msg.attachment_urls?.map((url, i) => (
//                     <img
//                       key={i}
//                       src={url}
//                       alt='attachment'
//                       style={{
//                         maxWidth: 120,
//                         margin: 4,
//                         borderRadius: 6,
//                         cursor: 'pointer',
//                       }}
//                       onClick={() => window.open(url, '_blank')}
//                     />
//                   ))}
//                 </Box>
//                 {msg.is_read && msg.sender_id === currentUser.id && (
//                   <Box display='flex' justifyContent='flex-end'>
//                     <BiCheckDouble color='#4fc3f7' size={18} />
//                   </Box>
//                 )}
//               </Paper>
//             ))
//           )}
//           <div ref={chatEndRef} />
//         </Box>

//         {/* Message Input */}
//         <Box
//           p={2}
//           borderTop='1px solid #eee'
//           bgcolor='#fff'
//           display='flex'
//           gap={1}
//         >
//           <input
//             type='file'
//             multiple
//             accept='image/*'
//             ref={fileInputRef}
//             onChange={handleFileChange}
//             style={{ display: 'none' }}
//             id='chat-file-upload'
//           />
//           <TextField
//             fullWidth
//             multiline
//             minRows={2}
//             maxRows={4}
//             value={messageText}
//             onChange={(e) => setMessageText(e.target.value)}
//             placeholder='Type your message...'
//             disabled={uploadingFiles || !connected}
//             onKeyDown={(e) => {
//               if (e.key === 'Enter' && !e.shiftKey) {
//                 e.preventDefault();
//                 handleSendMessage();
//               }
//             }}
//             InputProps={{
//               endAdornment: (
//                 <>
//                   <InputAdornment position='end'>
//                     <label htmlFor='chat-file-upload'>
//                       <IconButton
//                         component='span'
//                         size='small'
//                         disabled={uploadingFiles || !connected}
//                       >
//                         <AttachFileIcon
//                           color={
//                             uploadingFiles || !connected
//                               ? 'disabled'
//                               : 'primary'
//                           }
//                         />
//                       </IconButton>
//                     </label>
//                   </InputAdornment>
//                   <InputAdornment position='end'>
//                     <IconButton
//                       color='primary'
//                       onClick={handleSendMessage}
//                       disabled={
//                         (!messageText.trim() && attachments.length === 0) ||
//                         uploadingFiles ||
//                         !connected ||
//                         selectedUsers.length === 0
//                       }
//                       size='small'
//                     >
//                       {uploadingFiles ? (
//                         <CircularProgress size={20} />
//                       ) : (
//                         <SendIcon />
//                       )}
//                     </IconButton>
//                   </InputAdornment>
//                 </>
//               ),
//             }}
//           />
//         </Box>

//         {/* Preview attachments */}
//         {previewUrls.length > 0 && (
//           <Box p={2} display='flex' flexWrap='wrap' gap={1} bgcolor='#f1f8e9'>
//             <Typography variant='caption' sx={{ width: '100%', mb: 1 }}>
//               Attachments ({previewUrls.length}):
//             </Typography>
//             {previewUrls.map((url, i) => (
//               <Box key={i} position='relative'>
//                 <img
//                   src={url}
//                   alt='preview'
//                   style={{ maxWidth: 60, borderRadius: 6 }}
//                 />
//                 <IconButton
//                   size='small'
//                   sx={{
//                     position: 'absolute',
//                     top: -8,
//                     right: -8,
//                     bgcolor: 'error.main',
//                     color: 'white',
//                     width: 20,
//                     height: 20,
//                     '&:hover': { bgcolor: 'error.dark' },
//                   }}
//                   onClick={() => {
//                     const newAttachments = attachments.filter(
//                       (_, index) => index !== i
//                     );
//                     const newPreviewUrls = previewUrls.filter(
//                       (_, index) => index !== i
//                     );
//                     setAttachments(newAttachments);
//                     setPreviewUrls(newPreviewUrls);
//                   }}
//                 >
//                   ×
//                 </IconButton>
//               </Box>
//             ))}
//           </Box>
//         )}
//       </Box>
//     </Paper>
//   );
// }

// import React, { useState, useEffect, useRef } from 'react';
// import { io } from 'socket.io-client';
// import {
//   Paper,
//   Box,
//   Typography,
//   TextField,
//   IconButton,
//   Avatar,
//   List,
//   ListItem,
//   FormControlLabel,
//   Checkbox,
//   Divider,
//   InputAdornment,
//   CircularProgress,
//   Badge,
// } from '@mui/material';
// import {
//   Send as SendIcon,
//   AttachFile as AttachFileIcon,
//   Search as SearchIcon,
// } from '@mui/icons-material';
// import { BiCheckDouble } from 'react-icons/bi';
// import moment from 'moment';
// import { isEmpty, reverse, uniqBy } from 'lodash';

// const WS_URL = 'wss://procam.pythonanywhere.com/';

// export default function ControlRoomChat() {
//   const currentUser = {
//     id: parseInt(localStorage?.getItem('user_id')),
//     user_name: localStorage?.getItem('user_name'),
//     event_id: parseInt(localStorage?.getItem('event_id')),
//   };

//   const [users, setUsers] = useState([]);
//   const [selectedUsers, setSelectedUsers] = useState([]);
//   const [messages, setMessages] = useState([]);
//   const [messageText, setMessageText] = useState('');
//   const [attachments, setAttachments] = useState([]);
//   const [previewUrls, setPreviewUrls] = useState([]);
//   const [search, setSearch] = useState('');
//   const [loading, setLoading] = useState(false);
//   const [uploadingFiles, setUploadingFiles] = useState(false);
//   const [connected, setConnected] = useState(false);

//   // NEW: Add total unread count state
//   const [totalUnreadCount, setTotalUnreadCount] = useState(0);

//   const fileInputRef = useRef();
//   const chatEndRef = useRef();
//   const socketRef = useRef();

//   const isUserRole = localStorage?.getItem('roles')?.includes('USER');
//   const hasAmbulancePermission = (permission) =>
//     localStorage?.getItem('permissions')?.includes(permission);
//   const ambulanceTracker =
//     isUserRole && hasAmbulancePermission('AMBULANCE GPS');

//   // Scroll to bottom
//   const scrollToBottom = () => {
//     setTimeout(() => {
//       chatEndRef.current?.scrollIntoView({ behavior: 'smooth' });
//     }, 100);
//   };

//   // NEW: Calculate total unread count from users
//   const updateTotalUnreadCount = (usersList) => {
//     const total = usersList.reduce(
//       (sum, user) => sum + (user.unreadCount || 0),
//       0
//     );
//     setTotalUnreadCount(total);
//   };

//   // Convert files to base64 for socket transmission
//   const convertFilesToBase64 = (files) => {
//     return Promise.all(
//       files.map((file) => {
//         return new Promise((resolve) => {
//           const reader = new FileReader();
//           reader.onload = () => {
//             resolve({
//               name: file.name,
//               type: file.type,
//               size: file.size,
//               data: reader.result.split(',')[1],
//             });
//           };
//           reader.readAsDataURL(file);
//         });
//       })
//     );
//   };

//   const handleSendMessage = async (e) => {
//     if (e) e.preventDefault();
//     if (!messageText.trim() && attachments.length === 0) return;
//     if (selectedUsers.length === 0) return;
//     if (!socketRef.current || !connected) return;

//     console.log(
//       'Sending message:',
//       messageText,
//       'attachments:',
//       attachments.length
//     );

//     let attachment_urls = [];

//     if (attachments.length > 0) {
//       try {
//         setUploadingFiles(true);
//         const fileData = await convertFilesToBase64(attachments);

//         socketRef.current.emit('upload_files', {
//           files: fileData,
//           user_id: currentUser.id,
//           event_id: currentUser.event_id,
//         });

//         return;
//       } catch (error) {
//         setUploadingFiles(false);
//         console.error('Failed to convert files:', error);
//         return;
//       }
//     }

//     const tempId = `temp-${Date.now()}-${Math.random()}`;
//     const optimisticMessage = {
//       id: tempId,
//       sender_id: currentUser.id,
//       receiver_id: selectedUsers[0],
//       receiver_ids:
//         selectedUsers.length === 1 ? [selectedUsers[0]] : selectedUsers,
//       content: messageText,
//       attachment_urls,
//       event_id: currentUser.event_id,
//       timestamp: new Date().toISOString(),
//       is_read: false,
//       status: 'sending',
//     };

//     setMessages((prevMessages) => {
//       const updatedMessages = uniqBy(
//         [...prevMessages, optimisticMessage],
//         'id'
//       );
//       return updatedMessages;
//     });

//     const payload = {
//       sender_id: currentUser.id,
//       receiver_ids:
//         selectedUsers.length === 1 ? [selectedUsers[0]] : selectedUsers,
//       content: messageText,
//       attachment_urls,
//       event_id: currentUser.event_id,
//       timestamp: new Date().toISOString(),
//       is_read: false,
//       tempId: tempId,
//     };

//     console.log('Sending message payload:', payload);
//     socketRef.current.emit('send_message', payload);

//     setMessageText('');
//     setAttachments([]);
//     setPreviewUrls([]);
//     if (fileInputRef.current) fileInputRef.current.value = '';
//     scrollToBottom();
//   };

//   useEffect(() => {
//     const socket = io(WS_URL, {
//       transports: ['websocket'],
//     });

//     socketRef.current = socket;

//     socket.on('connect', () => {
//       console.log('Socket connected');
//       setConnected(true);

//       socket.emit('join', { user_id: currentUser.id });

//       // UPDATED: Only fetch messages if users are selected
//       if (!isEmpty(selectedUsers)) {
//         if (selectedUsers.length === 1) {
//           socket.emit('get_all_messages', {
//             event_id: currentUser.event_id,
//             user_id: selectedUsers[0],
//           });
//         } else {
//           // For multiple users, fetch messages for each
//           selectedUsers.forEach((userId) => {
//             socket.emit('get_all_messages', {
//               event_id: currentUser.event_id,
//               user_id: userId,
//             });
//           });
//         }
//       }

//       if (!ambulanceTracker) {
//         socket.emit('get_users_by_role', { role: 'ambulance' });
//       }
//     });

//     socket.on('disconnect', () => {
//       console.log('Socket disconnected');
//       setConnected(false);
//     });

//     // UPDATED: Filter messages based on selection
//     socket.on('get_all_messages_result', (msgs) => {
//       console.log('Fetched messages:', msgs);

//       // Filter messages to only show conversations with selected users
//       const filteredMessages = msgs.filter((msg) => {
//         if (ambulanceTracker) {
//           // For ambulance tracker, only show messages between current user and control room
//           return (
//             (msg.sender_id === currentUser.id &&
//               selectedUsers.includes(msg.receiver_id)) ||
//             (msg.receiver_id === currentUser.id &&
//               selectedUsers.includes(msg.sender_id))
//           );
//         } else {
//           // For control room, show messages with selected users
//           return (
//             (msg.sender_id === currentUser.id &&
//               selectedUsers.includes(msg.receiver_id)) ||
//             (msg.receiver_id === currentUser.id &&
//               selectedUsers.includes(msg.sender_id)) ||
//             (Array.isArray(msg.receiver_ids) &&
//               msg.receiver_ids.some((id) => selectedUsers.includes(id)))
//           );
//         }
//       });

//       setMessages(reverse(filteredMessages));
//       setLoading(false);
//       scrollToBottom();
//     });

//     socket.on('send_message_result', (result) => {
//       console.log('Send message result:', result);

//       if (result.success) {
//         setMessages((prevMessages) =>
//           prevMessages.map((msg) =>
//             msg.status === 'sending'
//               ? { ...msg, status: 'sent', id: result.message_id || msg.id }
//               : msg
//           )
//         );
//       } else {
//         console.error('Failed to send message:', result.error);
//         setMessages((prevMessages) =>
//           prevMessages.map((msg) =>
//             msg.status === 'sending' ? { ...msg, status: 'failed' } : msg
//           )
//         );
//       }
//     });

//     // UPDATED: Enhanced new message handler with proper filtering
//     socket.on('new_message', (msg) => {
//       console.log('Received new message:', msg);

//       // ENHANCED: Check if message should be visible based on user type and selection
//       const shouldShowMessage = () => {
//         if (ambulanceTracker) {
//           // For ambulance tracker, only show messages with selected control room users
//           return (
//             (msg.sender_id === currentUser.id &&
//               selectedUsers.includes(msg.receiver_id)) ||
//             (msg.receiver_id === currentUser.id &&
//               selectedUsers.includes(msg.sender_id)) ||
//             (Array.isArray(msg.receiver_ids) &&
//               msg.receiver_ids.includes(currentUser.id))
//           );
//         } else {
//           // For control room, show messages only with selected users
//           return (
//             selectedUsers.length > 0 &&
//             ((msg.sender_id === currentUser.id &&
//               (selectedUsers.includes(msg.receiver_id) ||
//                 (Array.isArray(msg.receiver_ids) &&
//                   msg.receiver_ids.some((id) =>
//                     selectedUsers.includes(id)
//                   )))) ||
//               (msg.receiver_id === currentUser.id &&
//                 selectedUsers.includes(msg.sender_id)) ||
//               (Array.isArray(msg.receiver_ids) &&
//                 msg.receiver_ids.includes(currentUser.id) &&
//                 selectedUsers.includes(msg.sender_id)))
//           );
//         }
//       };

//       if (shouldShowMessage()) {
//         setMessages((prev) => {
//           const isDuplicate = prev.some(
//             (existingMsg) =>
//               existingMsg.sender_id === msg.sender_id &&
//               existingMsg.content === msg.content &&
//               existingMsg.timestamp === msg.timestamp
//           );

//           if (!isDuplicate) {
//             const updatedMessages = uniqBy([...prev, msg], 'id');
//             console.log('Updated messages list:', updatedMessages.length);
//             return updatedMessages;
//           }
//           return prev;
//         });
//         scrollToBottom();
//       }

//       // UPDATED: Unread count logic with proper filtering
//       if (
//         msg.receiver_id === currentUser.id &&
//         msg.sender_id !== currentUser.id
//       ) {
//         setUsers((prevUsers) => {
//           const updatedUsers = prevUsers.map((u) => {
//             if (u.id === msg.sender_id) {
//               // Only increment if this chat is not currently selected AND user can see this message
//               const isCurrentlySelected = selectedUsers.includes(msg.sender_id);
//               const canSeeMessage = ambulanceTracker
//                 ? selectedUsers.includes(msg.sender_id)
//                 : true; // Control room can see all messages for counting

//               const newUnreadCount =
//                 isCurrentlySelected || !canSeeMessage
//                   ? u.unreadCount || 0
//                   : (u.unreadCount || 0) + 1;

//               return { ...u, unreadCount: newUnreadCount };
//             }
//             return u;
//           });

//           updateTotalUnreadCount(updatedUsers);
//           return updatedUsers;
//         });
//       }
//     });

//     socket.on('message_read', ({ msg_id }) => {
//       console.log('Message marked as read:', msg_id);
//       setMessages((prev) =>
//         prev.map((m) => (m.id === msg_id ? { ...m, is_read: true } : m))
//       );
//     });

//     socket.on('get_users_by_role_result', (users) => {
//       console.log('Fetched users:', users);
//       const usersWithUnread = users.map((user) => ({
//         ...user,
//         unreadCount: 0,
//       }));
//       setUsers(usersWithUnread);
//       updateTotalUnreadCount(usersWithUnread);
//     });

//     socket.on('upload_files_result', (result) => {
//       console.log('Upload files result:', result);
//       setUploadingFiles(false);

//       if (result.success) {
//         const tempId = `temp-${Date.now()}-${Math.random()}`;
//         const optimisticMessage = {
//           id: tempId,
//           sender_id: currentUser.id,
//           receiver_id: selectedUsers[0],
//           receiver_ids:
//             selectedUsers.length === 1 ? [selectedUsers[0]] : selectedUsers,
//           content: messageText,
//           attachment_urls: result.file_urls,
//           event_id: currentUser.event_id,
//           timestamp: new Date().toISOString(),
//           is_read: false,
//           status: 'sending',
//         };

//         setMessages((prevMessages) => {
//           const updatedMessages = uniqBy(
//             [...prevMessages, optimisticMessage],
//             'id'
//           );
//           return updatedMessages;
//         });

//         const payload = {
//           sender_id: currentUser.id,
//           receiver_ids:
//             selectedUsers.length === 1 ? [selectedUsers[0]] : selectedUsers,
//           content: messageText,
//           attachment_urls: result.file_urls,
//           event_id: currentUser.event_id,
//           timestamp: new Date().toISOString(),
//           is_read: false,
//           tempId: tempId,
//         };

//         console.log('Sending message with attachments:', payload);
//         socketRef.current.emit('send_message', payload);

//         setMessageText('');
//         setAttachments([]);
//         setPreviewUrls([]);
//         if (fileInputRef.current) fileInputRef.current.value = '';
//         scrollToBottom();
//       } else {
//         console.error('Failed to upload files:', result.error);
//       }
//     });

//     return () => {
//       socket.disconnect();
//     };
//   }, [currentUser.id, currentUser.event_id, selectedUsers, ambulanceTracker]);

//   // useEffect(() => {
//   //   const socket = io(WS_URL, {
//   //     transports: ['websocket'],
//   //   });

//   //   socketRef.current = socket;

//   //   socket.on('connect', () => {
//   //     console.log('Socket connected');
//   //     setConnected(true);

//   //     socket.emit('join', { user_id: currentUser.id });

//   //     if (!isEmpty(selectedUsers)) {
//   //       socket.emit('get_all_messages', {
//   //         event_id: currentUser.event_id,
//   //         user_id: selectedUsers[0],
//   //       });
//   //     }

//   //     if (!ambulanceTracker) {
//   //       socket.emit('get_users_by_role', { role: 'ambulance' });
//   //     }
//   //   });

//   //   socket.on('disconnect', () => {
//   //     console.log('Socket disconnected');
//   //     setConnected(false);
//   //   });

//   //   socket.on('get_all_messages_result', (msgs) => {
//   //     console.log('Fetched messages:', msgs);
//   //     setMessages(reverse(msgs));
//   //     setLoading(false);
//   //     scrollToBottom();
//   //   });

//   //   socket.on('send_message_result', (result) => {
//   //     console.log('Send message result:', result);

//   //     if (result.success) {
//   //       setMessages((prevMessages) =>
//   //         prevMessages.map((msg) =>
//   //           msg.status === 'sending'
//   //             ? { ...msg, status: 'sent', id: result.message_id || msg.id }
//   //             : msg
//   //         )
//   //       );
//   //     } else {
//   //       console.error('Failed to send message:', result.error);
//   //       setMessages((prevMessages) =>
//   //         prevMessages.map((msg) =>
//   //           msg.status === 'sending' ? { ...msg, status: 'failed' } : msg
//   //         )
//   //       );
//   //     }
//   //   });

//   //   // UPDATED: Enhanced new message handler with unread count logic
//   //   socket.on('new_message', (msg) => {
//   //     console.log('Received new message:', msg);

//   //     if (
//   //       msg.receiver_id === currentUser.id ||
//   //       msg.sender_id === currentUser.id ||
//   //       selectedUsers.includes(msg.sender_id) ||
//   //       (Array.isArray(msg.receiver_id) && msg.receiver_id.includes(currentUser.id))
//   //     ) {
//   //       setMessages((prev) => {
//   //         const isDuplicate = prev.some(
//   //           (existingMsg) =>
//   //             existingMsg.sender_id === msg.sender_id &&
//   //             existingMsg.content === msg.content &&
//   //             existingMsg.timestamp === msg.timestamp
//   //         );

//   //         if (!isDuplicate) {
//   //           const updatedMessages = uniqBy([...prev, msg], 'id');
//   //           console.log('Updated messages list:', updatedMessages.length);
//   //           return updatedMessages;
//   //         }
//   //         return prev;
//   //       });
//   //       scrollToBottom();
//   //     }

//   //     // NEW: Enhanced unread count logic
//   //     if (msg.receiver_id === currentUser.id && msg.sender_id !== currentUser.id) {
//   //       setUsers((prevUsers) => {
//   //         const updatedUsers = prevUsers.map((u) => {
//   //           if (u.id === msg.sender_id) {
//   //             // Only increment if this chat is not currently selected (visible)
//   //             const isCurrentlySelected = selectedUsers.includes(msg.sender_id);
//   //             const newUnreadCount = isCurrentlySelected
//   //               ? u.unreadCount || 0
//   //               : (u.unreadCount || 0) + 1;

//   //             return { ...u, unreadCount: newUnreadCount };
//   //           }
//   //           return u;
//   //         });

//   //         // Update total unread count
//   //         updateTotalUnreadCount(updatedUsers);
//   //         return updatedUsers;
//   //       });
//   //     }
//   //   });

//   //   socket.on('message_read', ({ msg_id }) => {
//   //     console.log('Message marked as read:', msg_id);
//   //     setMessages((prev) =>
//   //       prev.map((m) => (m.id === msg_id ? { ...m, is_read: true } : m))
//   //     );
//   //   });

//   //   socket.on('get_users_by_role_result', (users) => {
//   //     console.log('Fetched users:', users);
//   //     const usersWithUnread = users.map((user) => ({ ...user, unreadCount: 0 }));
//   //     setUsers(usersWithUnread);
//   //     updateTotalUnreadCount(usersWithUnread);
//   //   });

//   //   socket.on('upload_files_result', (result) => {
//   //     console.log('Upload files result:', result);
//   //     setUploadingFiles(false);

//   //     if (result.success) {
//   //       const tempId = `temp-${Date.now()}-${Math.random()}`;
//   //       const optimisticMessage = {
//   //         id: tempId,
//   //         sender_id: currentUser.id,
//   //         receiver_id: selectedUsers[0],
//   //         receiver_ids: selectedUsers.length === 1 ? [selectedUsers[0]] : selectedUsers,
//   //         content: messageText,
//   //         attachment_urls: result.file_urls,
//   //         event_id: currentUser.event_id,
//   //         timestamp: new Date().toISOString(),
//   //         is_read: false,
//   //         status: 'sending',
//   //       };

//   //       setMessages((prevMessages) => {
//   //         const updatedMessages = uniqBy([...prevMessages, optimisticMessage], 'id');
//   //         return updatedMessages;
//   //       });

//   //       const payload = {
//   //         sender_id: currentUser.id,
//   //         receiver_ids: selectedUsers.length === 1 ? [selectedUsers[0]] : selectedUsers,
//   //         content: messageText,
//   //         attachment_urls: result.file_urls,
//   //         event_id: currentUser.event_id,
//   //         timestamp: new Date().toISOString(),
//   //         is_read: false,
//   //         tempId: tempId,
//   //       };

//   //       console.log('Sending message with attachments:', payload);
//   //       socketRef.current.emit('send_message', payload);

//   //       setMessageText('');
//   //       setAttachments([]);
//   //       setPreviewUrls([]);
//   //       if (fileInputRef.current) fileInputRef.current.value = '';
//   //       scrollToBottom();
//   //     } else {
//   //       console.error('Failed to upload files:', result.error);
//   //     }
//   //   });

//   //   return () => {
//   //     socket.disconnect();
//   //   };
//   // }, [currentUser.id, currentUser.event_id]);

//   // UPDATED: Enhanced mark as read handler
//   const handleMarkAsRead = (msgId, senderId) => {
//     console.log('Marking message as read:', msgId, 'from sender:', senderId);

//     setMessages((prev) =>
//       prev.map((m) => (m.id === msgId ? { ...m, is_read: true } : m))
//     );

//     if (senderId) {
//       setUsers((prev) => {
//         const updatedUsers = prev.map((u) =>
//           u.id === senderId ? { ...u, unreadCount: 0 } : u
//         );
//         updateTotalUnreadCount(updatedUsers);
//         return updatedUsers;
//       });
//     }

//     if (socketRef.current) {
//       socketRef.current.emit('mark_message_read', { message_id: msgId });
//     }
//   };

//   // NEW: Mark all messages as read for selected users
//   const markSelectedMessagesAsRead = () => {
//     if (selectedUsers.length === 0) return;

//     // Mark all unread messages from selected users as read
//     const unreadMessages = messages.filter(
//       (msg) =>
//         !msg.is_read &&
//         msg.receiver_id === currentUser.id &&
//         selectedUsers.includes(msg.sender_id)
//     );

//     unreadMessages.forEach((msg) => {
//       handleMarkAsRead(msg.id, msg.sender_id);
//     });

//     // Reset unread count for selected users
//     setUsers((prev) => {
//       const updatedUsers = prev.map((u) =>
//         selectedUsers.includes(u.id) ? { ...u, unreadCount: 0 } : u
//       );
//       updateTotalUnreadCount(updatedUsers);
//       return updatedUsers;
//     });
//   };

//   const handleFileChange = (e) => {
//     const files = Array.from(e.target.files);
//     console.log('Files selected:', files.length);
//     setAttachments(files);

//     const urls = files.map((file) => URL.createObjectURL(file));
//     setPreviewUrls(urls);
//   };

//   useEffect(() => {
//     if (ambulanceTracker) {
//       setSelectedUsers([58]);
//     }
//   }, [ambulanceTracker]);

//   // NEW: Mark messages as read when selected users change
//   // useEffect(() => {
//   //   if (!isEmpty(selectedUsers) && socketRef.current && connected) {
//   //     setLoading(true);
//   //     socketRef.current.emit('get_all_messages', {
//   //       event_id: currentUser.event_id,
//   //       user_id: selectedUsers[0],
//   //     });

//   //     // Mark messages as read when opening a chat
//   //     setTimeout(() => {
//   //       markSelectedMessagesAsRead();
//   //     }, 1000);
//   //   }
//   // }, [selectedUsers, connected]);

//   // UPDATED: Enhanced useEffect for user selection changes
//   useEffect(() => {
//     if (!isEmpty(selectedUsers) && socketRef.current && connected) {
//       setLoading(true);

//       // Clear existing messages when switching users
//       setMessages([]);

//       if (selectedUsers.length === 1) {
//         // Single user conversation
//         console.log('Fetching messages for user:', selectedUsers[0]);
//         socketRef.current.emit('get_all_messages', {
//           event_id: currentUser.event_id,
//           user_id: selectedUsers[0],
//         });
//       } else if (selectedUsers.length > 1) {
//         // Multiple users - fetch for each
//         console.log('Fetching messages for users:', selectedUsers);
//         selectedUsers.forEach((userId, index) => {
//           setTimeout(() => {
//             socketRef.current.emit('get_all_messages', {
//               event_id: currentUser.event_id,
//               user_id: userId,
//             });
//           }, index * 100); // Small delay between requests
//         });
//       }

//       // Mark messages as read when opening a chat
//       const readTimeout = setTimeout(() => {
//         markSelectedMessagesAsRead();
//       }, 1000);

//       return () => clearTimeout(readTimeout);
//     } else {
//       console.log('selectedUsers', selectedUsers);

//       // Clear messages when no users selected
//       setMessages([]);
//       setLoading(false);
//     }
//   }, [selectedUsers, connected]);

//   return (
//     <Paper
//       elevation={4}
//       sx={{
//         display: 'flex',
//         height: ambulanceTracker ? '85vh' : '100vh',
//         borderRadius: 3,
//         overflow: 'hidden',
//       }}
//     >
//       {/* Sidebar */}
//       {!ambulanceTracker && (
//         <Box
//           width={{ md: 300, sm: 190 }}
//           display='flex'
//           flexDirection='column'
//           bgcolor='#f7f9fc'
//           borderRight='1px solid #e0e0e0'
//         >
//           <Box p={2} pb={0}>
//             {/* NEW: Display total unread count in header */}
//             <Box
//               display='flex'
//               alignItems='center'
//               justifyContent='space-between'
//             >
//               <Typography variant='h6' sx={{ fontWeight: 600 }}>
//                 Operators
//               </Typography>
//               {totalUnreadCount > 0 && (
//                 <Badge
//                   badgeContent={totalUnreadCount}
//                   color='error'
//                   sx={{
//                     '& .MuiBadge-badge': {
//                       fontSize: '0.75rem',
//                       fontWeight: 600,
//                     },
//                   }}
//                 >
//                   <Typography variant='caption' color='text.secondary'>
//                     Total
//                   </Typography>
//                 </Badge>
//               )}
//             </Box>

//             <TextField
//               size='small'
//               placeholder='Search operator'
//               value={search}
//               onChange={(e) => setSearch(e.target.value)}
//               InputProps={{
//                 startAdornment: (
//                   <InputAdornment position='start'>
//                     <SearchIcon color='action' />
//                   </InputAdornment>
//                 ),
//               }}
//               sx={{ mt: 1, mb: 1.5, width: '100%' }}
//             />
//             <FormControlLabel
//               sx={{ mb: 1 }}
//               control={
//                 <Checkbox
//                   checked={selectedUsers.length === users.length}
//                   onChange={(e) =>
//                     setSelectedUsers(
//                       e.target.checked ? users.map((u) => u.id) : []
//                     )
//                   }
//                 />
//               }
//               label='Broadcast All'
//             />
//           </Box>
//           <Divider />
//           <List dense sx={{ flex: 1, overflow: 'auto', px: 1 }}>
//             {users
//               ?.filter(
//                 (u) =>
//                   u.username?.toLowerCase().includes(search.toLowerCase()) ||
//                   u.phone?.includes(search)
//               )
//               .map((u) => (
//                 <ListItem
//                   key={u.id}
//                   disablePadding
//                   sx={{
//                     '&:hover': { bgcolor: '#eef3fb' },
//                     borderRadius: 1,
//                     px: 1,
//                   }}
//                 >
//                   <FormControlLabel
//                     sx={{ width: '100%', px: 1 }}
//                     control={
//                       <Checkbox
//                         checked={selectedUsers.includes(u.id)}
//                         onChange={(e) =>
//                           e.target.checked
//                             ? setSelectedUsers([...selectedUsers, u.id])
//                             : setSelectedUsers(
//                                 selectedUsers.filter((id) => id !== u.id)
//                               )
//                         }
//                       />
//                     }
//                     label={
//                       <Box
//                         display='flex'
//                         justifyContent='space-between'
//                         alignItems='center'
//                       >
//                         <Typography variant='body2'>
//                           {u.username} <br /> {u.phone}
//                         </Typography>
//                         {/* UPDATED: Enhanced unread count display */}
//                         {u.unreadCount > 0 && (
//                           <Badge
//                             badgeContent={u.unreadCount}
//                             color='error'
//                             sx={{
//                               '& .MuiBadge-badge': {
//                                 animation: 'pulse 2s infinite',
//                                 '@keyframes pulse': {
//                                   '0%': {
//                                     transform: 'scale(1)',
//                                   },
//                                   '50%': {
//                                     transform: 'scale(1.1)',
//                                   },
//                                   '100%': {
//                                     transform: 'scale(1)',
//                                   },
//                                 },
//                               },
//                             }}
//                           >
//                             <Box
//                               sx={{
//                                 bgcolor: 'transparent',
//                                 width: 8,
//                                 height: 8,
//                               }}
//                             />
//                           </Badge>
//                         )}
//                       </Box>
//                     }
//                   />
//                 </ListItem>
//               ))}
//           </List>
//         </Box>
//       )}

//       {/* Chat Area - Rest remains the same */}
//       <Box flex={1} display='flex' flexDirection='column' bgcolor='#f9fafb'>
//         {/* Header */}
//         <Box
//           py={2}
//           px={2}
//           borderBottom='1px solid #eee'
//           bgcolor='#fff'
//           display='flex'
//           alignItems='center'
//           boxShadow='0px 1px 4px rgba(0,0,0,0.1)'
//           gap={1}
//         >
//           <Avatar
//             sx={{ bgcolor: '#007bff', width: 32, height: 32, fontWeight: 600 }}
//           >
//             C
//           </Avatar>
//           <Typography variant='subtitle1' sx={{ fontWeight: 550 }}>
//             CONTROL ROOM
//           </Typography>
//           {!connected && (
//             <Typography variant='caption' color='error' sx={{ ml: 'auto' }}>
//               Disconnected
//             </Typography>
//           )}
//           {connected && (
//             <Typography
//               variant='caption'
//               color='success.main'
//               sx={{ ml: 'auto' }}
//             >
//               Connected
//             </Typography>
//           )}
//         </Box>

//         {/* Messages - Rest of the component remains the same */}
//         <Box flex={1} overflow='auto' p={2}>
//           {loading ? (
//             <Box display='flex' justifyContent='center' mt={5}>
//               <CircularProgress />
//             </Box>
//           ) : (
//             messages.map((msg) => (
//               <Paper
//                 key={msg.id}
//                 elevation={1}
//                 sx={{
//                   mb: 2,
//                   p: 1.5,
//                   width: 'fit-content',
//                   ml: msg.sender_id === currentUser.id ? 'auto' : 0,
//                   background:
//                     msg.sender_id === currentUser.id ? '#e8f4fd' : '#fff',
//                   borderLeft:
//                     msg.sender_id === currentUser.id
//                       ? '4px solid #1976d2'
//                       : '4px solid #118C7E',
//                   borderRadius: 2,
//                   cursor:
//                     !msg.is_read && msg.receiver_id === currentUser.id
//                       ? 'pointer'
//                       : 'default',
//                 }}
//                 onClick={() =>
//                   !msg.is_read &&
//                   msg.receiver_id === currentUser.id &&
//                   handleMarkAsRead(msg.id, msg.sender_id)
//                 }
//               >
//                 <Box display='flex' alignItems='center' mb={0.5}>
//                   <Avatar
//                     sx={{
//                       width: 25,
//                       height: 25,
//                       mr: 1,
//                       bgcolor:
//                         msg.sender_id !== currentUser.id
//                           ? '#118C7E'
//                           : '#1976d2',
//                       fontSize: '0.7rem',
//                       fontWeight: 550,
//                     }}
//                   >
//                     {msg.sender_id === currentUser.id
//                       ? currentUser.user_name?.[0]?.toUpperCase()
//                       : users
//                           .find((u) => u.id === msg.sender_id)
//                           ?.username?.[0]?.toUpperCase() || 'U'}
//                   </Avatar>
//                   <Typography variant='caption' sx={{ fontWeight: 600 }}>
//                     {msg.sender_id === currentUser.id
//                       ? 'You'
//                       : users.find((u) => u.id === msg.sender_id)?.username ||
//                         'CONTROL ROOM'}
//                   </Typography>
//                   <Typography
//                     variant='caption'
//                     color='text.secondary'
//                     sx={{ ml: 1 }}
//                   >
//                     {moment(msg.timestamp).format('hh:mm A')}
//                   </Typography>
//                 </Box>
//                 {msg.content && (
//                   <Typography
//                     variant='body2'
//                     sx={{ mb: 0.5, whiteSpace: 'pre-wrap' }}
//                   >
//                     {msg.content}
//                   </Typography>
//                 )}
//                 <Box display='flex' flexWrap='wrap'>
//                   {msg.attachment_urls?.map((url, i) => (
//                     <img
//                       key={i}
//                       src={url}
//                       alt='attachment'
//                       style={{
//                         maxWidth: 120,
//                         margin: 4,
//                         borderRadius: 6,
//                         cursor: 'pointer',
//                       }}
//                       onClick={() => window.open(url, '_blank')}
//                     />
//                   ))}
//                 </Box>
//                 {msg.is_read && msg.sender_id === currentUser.id && (
//                   <Box display='flex' justifyContent='flex-end'>
//                     <BiCheckDouble color='#4fc3f7' size={18} />
//                   </Box>
//                 )}
//               </Paper>
//             ))
//           )}
//           <div ref={chatEndRef} />
//         </Box>

//         {/* Message Input - Rest remains the same */}
//         <Box
//           p={2}
//           borderTop='1px solid #eee'
//           bgcolor='#fff'
//           display='flex'
//           gap={1}
//         >
//           <input
//             type='file'
//             multiple
//             accept='image/*'
//             ref={fileInputRef}
//             onChange={handleFileChange}
//             style={{ display: 'none' }}
//             id='chat-file-upload'
//           />
//           <TextField
//             fullWidth
//             multiline
//             minRows={2}
//             maxRows={4}
//             value={messageText}
//             onChange={(e) => setMessageText(e.target.value)}
//             placeholder='Type your message...'
//             disabled={uploadingFiles || !connected}
//             onKeyDown={(e) => {
//               if (e.key === 'Enter' && !e.shiftKey) {
//                 e.preventDefault();
//                 handleSendMessage();
//               }
//             }}
//             InputProps={{
//               endAdornment: (
//                 <>
//                   <InputAdornment position='end'>
//                     <label htmlFor='chat-file-upload'>
//                       <IconButton
//                         component='span'
//                         size='small'
//                         disabled={uploadingFiles || !connected}
//                       >
//                         <AttachFileIcon
//                           color={
//                             uploadingFiles || !connected
//                               ? 'disabled'
//                               : 'primary'
//                           }
//                         />
//                       </IconButton>
//                     </label>
//                   </InputAdornment>
//                   <InputAdornment position='end'>
//                     <IconButton
//                       color='primary'
//                       onClick={handleSendMessage}
//                       disabled={
//                         (!messageText.trim() && attachments.length === 0) ||
//                         uploadingFiles ||
//                         !connected ||
//                         selectedUsers.length === 0
//                       }
//                       size='small'
//                     >
//                       {uploadingFiles ? (
//                         <CircularProgress size={20} />
//                       ) : (
//                         <SendIcon />
//                       )}
//                     </IconButton>
//                   </InputAdornment>
//                 </>
//               ),
//             }}
//           />
//         </Box>

//         {/* Preview attachments - Rest remains the same */}
//         {previewUrls.length > 0 && (
//           <Box p={2} display='flex' flexWrap='wrap' gap={1} bgcolor='#f1f8e9'>
//             <Typography variant='caption' sx={{ width: '100%', mb: 1 }}>
//               Attachments ({previewUrls.length}):
//             </Typography>
//             {previewUrls.map((url, i) => (
//               <Box key={i} position='relative'>
//                 <img
//                   src={url}
//                   alt='preview'
//                   style={{ maxWidth: 60, borderRadius: 6 }}
//                 />
//                 <IconButton
//                   size='small'
//                   sx={{
//                     position: 'absolute',
//                     top: -8,
//                     right: -8,
//                     bgcolor: 'error.main',
//                     color: 'white',
//                     width: 20,
//                     height: 20,
//                     '&:hover': { bgcolor: 'error.dark' },
//                   }}
//                   onClick={() => {
//                     const newAttachments = attachments.filter(
//                       (_, index) => index !== i
//                     );
//                     const newPreviewUrls = previewUrls.filter(
//                       (_, index) => index !== i
//                     );
//                     setAttachments(newAttachments);
//                     setPreviewUrls(newPreviewUrls);
//                   }}
//                 >
//                   ×
//                 </IconButton>
//               </Box>
//             ))}
//           </Box>
//         )}
//       </Box>
//     </Paper>
//   );
// }

// import React, { useState, useEffect, useRef, useCallback } from 'react';
// import { io } from 'socket.io-client';
// import {
//   Paper,
//   Box,
//   Typography,
//   TextField,
//   IconButton,
//   Avatar,
//   InputAdornment,
//   CircularProgress,
//   Chip,
//   Tooltip,
//   Alert,
//   Snackbar,
//   Badge,
//   FormControlLabel,
//   Checkbox,
//   Divider,
//   List,
//   ListItem,
// } from '@mui/material';
// import {
//   Send as SendIcon,
//   AttachFile as AttachFileIcon,
//   Close as CloseIcon,
//   Refresh as RefreshIcon,
// } from '@mui/icons-material';
// import { BiCheckDouble, BiCheck } from 'react-icons/bi';
// import moment from 'moment';
// import { isEmpty, map, reverse, uniqBy, debounce } from 'lodash';
// import {
//   Search as SearchIcon,
//   CampaignOutlined as BroadcastIcon,
// } from '@mui/icons-material';

// const WS_URL = 'wss:///';

// export const AmbulanceTrackerChat = () => {
//   // Current user data from localStorage
//   const currentUser = {
//     id: parseInt(localStorage?.getItem('user_id')),
//     user_name: localStorage?.getItem('user_name'),
//     event_id: parseInt(localStorage?.getItem('event_id')),
//   };

//   // State management
//   const [messages, setMessages] = useState([]);
//   const [messageText, setMessageText] = useState('');
//   const [attachments, setAttachments] = useState([]);
//   const [previewUrls, setPreviewUrls] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [uploadingFiles, setUploadingFiles] = useState(false);
//   const [connected, setConnected] = useState(false);
//   const [reconnecting, setReconnecting] = useState(false);
//   const [error, setError] = useState('');
//   const [typing, setTyping] = useState(false);
//   const [controlRoomTyping, setControlRoomTyping] = useState(false);
//   const [unreadCount, setUnreadCount] = useState(0);

//   // Refs
//   const fileInputRef = useRef();
//   const chatEndRef = useRef();
//   const socketRef = useRef();
//   const typingTimeoutRef = useRef();

//   // Constants
//   const CONTROL_ROOM_USER_ID = 58;
//   const MAX_FILE_SIZE = 10 * 1024 * 1024; // 10MB
//   const ALLOWED_FILE_TYPES = [
//     'image/jpeg',
//     'image/png',
//     'image/gif',
//     'image/webp',
//   ];

//   // Scroll to bottom function
//   const scrollToBottom = useCallback(() => {
//     setTimeout(() => {
//       chatEndRef.current?.scrollIntoView({ behavior: 'smooth' });
//     }, 100);
//   }, []);

//   // File validation
//   const validateFiles = (files) => {
//     const errors = [];

//     files.forEach((file) => {
//       if (file.size > MAX_FILE_SIZE) {
//         errors.push(`${file.name} is too large (max 10MB)`);
//       }
//       if (!ALLOWED_FILE_TYPES.includes(file.type)) {
//         errors.push(`${file.name} is not a supported image format`);
//       }
//     });

//     return errors;
//   };

//   // Convert files to base64
//   const convertFilesToBase64 = (files) => {
//     return Promise.all(
//       files.map((file) => {
//         return new Promise((resolve, reject) => {
//           const reader = new FileReader();
//           reader.onload = () => {
//             resolve({
//               name: file.name,
//               type: file.type,
//               size: file.size,
//               data: reader.result.split(',')[1],
//             });
//           };
//           reader.onerror = reject;
//           reader.readAsDataURL(file);
//         });
//       })
//     );
//   };

//   // Typing indicator
//   const handleTyping = debounce(() => {
//     if (socketRef.current && connected) {
//       socketRef.current.emit('typing', {
//         user_id: currentUser.id,
//         receiver_id: CONTROL_ROOM_USER_ID,
//         event_id: currentUser.event_id,
//         is_typing: true,
//       });

//       // Stop typing after 3 seconds
//       clearTimeout(typingTimeoutRef.current);
//       typingTimeoutRef.current = setTimeout(() => {
//         socketRef.current.emit('typing', {
//           user_id: currentUser.id,
//           receiver_id: CONTROL_ROOM_USER_ID,
//           event_id: currentUser.event_id,
//           is_typing: false,
//         });
//       }, 3000);
//     }
//   }, 500);

//   // Send message function
//   const handleSendMessage = async (e) => {
//     if (e) e.preventDefault();
//     if (!messageText.trim() && attachments.length === 0) return;
//     if (!socketRef.current || !connected) {
//       setError('Cannot send message: Not connected to server');
//       return;
//     }

//     let attachment_urls = [];

//     // Handle file uploads first
//     if (attachments.length > 0) {
//       const fileErrors = validateFiles(attachments);
//       if (fileErrors.length > 0) {
//         setError(fileErrors.join(', '));
//         return;
//       }

//       try {
//         setUploadingFiles(true);
//         const fileData = await convertFilesToBase64(attachments);

//         socketRef.current.emit('upload_files', {
//           files: fileData,
//           user_id: currentUser.id,
//           event_id: currentUser.event_id,
//         });
//         return;
//       } catch (error) {
//         setUploadingFiles(false);
//         setError('Failed to process files');
//         console.error('Failed to convert files:', error);
//         return;
//       }
//     }

//     // Create optimistic message
//     const tempId = `temp-${Date.now()}-${Math.random()}`;
//     const timestamp = new Date().toISOString();

//     const optimisticMessage = {
//       id: tempId,
//       sender_id: currentUser.id,
//       receiver_id: CONTROL_ROOM_USER_ID,
//       content: messageText,
//       attachment_urls,
//       event_id: currentUser.event_id,
//       timestamp,
//       is_read: false,
//       status: 'sending',
//       msg_sender: 'You',
//     };

//     // Add optimistic message to UI
//     setMessages((prevMessages) => {
//       return uniqBy([...prevMessages, optimisticMessage], 'id');
//     });

//     // Prepare payload
//     const payload = {
//       sender_id: currentUser.id,
//       receiver_ids: [CONTROL_ROOM_USER_ID],
//       content: messageText,
//       attachment_urls,
//       event_id: currentUser.event_id,
//       timestamp,
//       is_read: false,
//       tempId,
//     };

//     // Send message via socket
//     socketRef.current.emit('send_message', payload);

//     // Clear inputs
//     setMessageText('');
//     setAttachments([]);
//     setPreviewUrls([]);
//     if (fileInputRef.current) fileInputRef.current.value = '';

//     // Stop typing indicator
//     socketRef.current.emit('typing', {
//       user_id: currentUser.id,
//       receiver_id: CONTROL_ROOM_USER_ID,
//       event_id: currentUser.event_id,
//       is_typing: false,
//     });

//     scrollToBottom();
//   };

//   // Mark message as read
//   const handleMarkAsRead = (msgId) => {
//     if (!msgId) return;

//     setMessages((prev) =>
//       prev.map((m) => (m.id === msgId ? { ...m, is_read: true } : m))
//     );

//     if (socketRef.current && connected) {
//       socketRef.current.emit('mark_message_read', {
//         message_id: msgId,
//         user_id: currentUser.id,
//         event_id: currentUser.event_id,
//       });
//     }
//   };

//   // File input handler
//   const handleFileChange = (e) => {
//     const files = Array.from(e.target.files);

//     const fileErrors = validateFiles(files);
//     if (fileErrors.length > 0) {
//       setError(fileErrors.join(', '));
//       return;
//     }

//     setAttachments(files);
//     const urls = files.map((file) => URL.createObjectURL(file));
//     setPreviewUrls(urls);
//   };

//   // Remove attachment
//   const removeAttachment = (index) => {
//     const newAttachments = attachments.filter((_, i) => i !== index);
//     const newPreviewUrls = previewUrls.filter((_, i) => i !== index);
//     setAttachments(newAttachments);
//     setPreviewUrls(newPreviewUrls);

//     // Clear file input if no attachments left
//     if (newAttachments.length === 0 && fileInputRef.current) {
//       fileInputRef.current.value = '';
//     }
//   };

//   // Reconnect function
//   const handleReconnect = () => {
//     if (socketRef.current) {
//       setReconnecting(true);
//       socketRef.current.disconnect();
//       socketRef.current.connect();
//     }
//   };

//   // Socket connection effect
//   useEffect(() => {
//     const socket = io(WS_URL, {
//       transports: ['websocket'],
//       reconnection: true,
//       reconnectionDelay: 1000,
//       reconnectionAttempts: 5,
//       timeout: 20000,
//       forceNew: true,
//     });

//     socketRef.current = socket;

//     // Connection events
//     socket.on('connect', () => {
//       console.log('Ambulance Socket connected');
//       setConnected(true);
//       setReconnecting(false);
//       setError('');
//       setLoading(true);

//       // Join ambulance specific channel
//       socket.emit('join', {
//         user_id: currentUser.id,
//         event_id: currentUser.event_id,
//       });

//       // Fetch messages
//       socket.emit('get_all_messages', {
//         event_id: currentUser.event_id,
//         user_id: CONTROL_ROOM_USER_ID,
//         receiver_id: currentUser.id,
//         sender_id: CONTROL_ROOM_USER_ID,
//       });
//     });

//     socket.on('reconnect', (attemptNumber) => {
//       console.log(
//         'Ambulance Socket reconnected after',
//         attemptNumber,
//         'attempts'
//       );
//       setConnected(true);
//       setReconnecting(false);
//       setError('');
//     });

//     socket.on('disconnect', (reason) => {
//       console.log('Ambulance Socket disconnected:', reason);
//       setConnected(false);
//       if (reason === 'io server disconnect') {
//         socket.connect();
//       }
//     });

//     socket.on('connect_error', (error) => {
//       console.error('Connection error:', error);
//       setError('Connection failed. Please check your internet connection.');
//     });

//     // Message events
//     socket.on('get_all_messages_result', (msgs) => {
//       console.log('Ambulance - Fetched messages:', msgs);

//       // Filter messages for ambulance <-> control room
//       const filteredMessages = msgs.filter((msg) => {
//         return (
//           msg.event_id === currentUser.event_id &&
//           ((msg.sender_id === currentUser.id &&
//             msg.receiver_id === CONTROL_ROOM_USER_ID) ||
//             (msg.sender_id === CONTROL_ROOM_USER_ID &&
//               msg.receiver_id === currentUser.id) ||
//             (Array.isArray(msg.receiver_ids) &&
//               msg.receiver_ids.includes(currentUser.id)))
//         );
//       });

//       console.log('Filtered messages for ambulance tracker:', filteredMessages);

//       const processedMessages = map(reverse(msgs), (data) => {
//         return {
//           ...data,
//           msg_sender:
//             data?.sender_id === parseInt(currentUser.id)
//               ? 'You'
//               : 'Control Room',
//         };
//       });

//       setMessages(processedMessages);

//       // Count unread messages from control room
//       const unreadFromControlRoom = processedMessages.filter(
//         (msg) => !msg.is_read && msg.sender_id === CONTROL_ROOM_USER_ID
//       ).length;
//       setUnreadCount(unreadFromControlRoom);

//       setLoading(false);
//       scrollToBottom();
//     });

//     socket.on('send_message_result', (result) => {
//       if (result.success) {
//         setMessages((prevMessages) =>
//           prevMessages.map((msg) =>
//             msg.status === 'sending' && msg.id === result.tempId
//               ? { ...msg, status: 'sent', id: result.message_id || msg.id }
//               : msg
//           )
//         );
//       } else {
//         console.error('Failed to send message:', result.error);
//         setError('Failed to send message: ' + result.error);
//         setMessages((prevMessages) =>
//           prevMessages.map((msg) =>
//             msg.status === 'sending' ? { ...msg, status: 'failed' } : msg
//           )
//         );
//       }
//     });

//     socket.on('new_message', (msg) => {
//       console.log('Ambulance - Received new message:', msg);

//       // Filter for ambulance <-> control room communication
//       const shouldShowMessage =
//         msg.event_id === currentUser.event_id &&
//         ((msg.sender_id === currentUser.id &&
//           msg.receiver_id === CONTROL_ROOM_USER_ID) ||
//           (msg.sender_id === CONTROL_ROOM_USER_ID &&
//             msg.receiver_id === currentUser.id) ||
//           (Array.isArray(msg.receiver_ids) &&
//             msg.receiver_ids.includes(currentUser.id)));

//       if (shouldShowMessage) {
//         setMessages((prev) => {
//           // Check for duplicates
//           const isDuplicate = prev.some(
//             (existingMsg) =>
//               existingMsg.id === msg.id ||
//               (existingMsg.sender_id === msg.sender_id &&
//                 existingMsg.content === msg.content &&
//                 Math.abs(
//                   new Date(existingMsg.timestamp) - new Date(msg.timestamp)
//                 ) < 1000)
//           );

//           if (!isDuplicate) {
//             const newMessage = {
//               ...msg,
//               msg_sender:
//                 msg.sender_id === parseInt(currentUser.id)
//                   ? 'You'
//                   : 'Control Room',
//             };

//             // Update unread count if message is from control room
//             if (msg.sender_id === CONTROL_ROOM_USER_ID && !msg.is_read) {
//               setUnreadCount((prevCount) => prevCount + 1);
//             }

//             return uniqBy([...prev, newMessage], 'id');
//           }
//           return prev;
//         });

//         // Auto-mark messages as read after a delay if from control room
//         if (msg.sender_id === CONTROL_ROOM_USER_ID && !msg.is_read) {
//           setTimeout(() => {
//             handleMarkAsRead(msg.id);
//             setUnreadCount((prevCount) => Math.max(0, prevCount - 1));
//           }, 2000);
//         }

//         scrollToBottom();
//       }
//     });

//     socket.on('message_read', ({ msg_id, read_by }) => {
//       setMessages((prev) =>
//         prev.map((m) => (m.id === msg_id ? { ...m, is_read: true } : m))
//       );
//     });

//     socket.on('message_read_confirmation', ({ message_id, read_by }) => {
//       if (read_by === CONTROL_ROOM_USER_ID) {
//         setMessages((prev) =>
//           prev.map((m) => (m.id === message_id ? { ...m, is_read: true } : m))
//         );
//       }
//     });

//     // File upload events
//     socket.on('upload_files_result', (result) => {
//       setUploadingFiles(false);

//       if (result.success) {
//         const tempId = `temp-${Date.now()}-${Math.random()}`;
//         const timestamp = new Date().toISOString();

//         const optimisticMessage = {
//           id: tempId,
//           sender_id: currentUser.id,
//           receiver_id: CONTROL_ROOM_USER_ID,
//           content: messageText,
//           attachment_urls: result.file_urls,
//           event_id: currentUser.event_id,
//           timestamp,
//           is_read: false,
//           status: 'sending',
//           msg_sender: 'You',
//         };

//         setMessages((prevMessages) => {
//           return uniqBy([...prevMessages, optimisticMessage], 'id');
//         });

//         const payload = {
//           sender_id: currentUser.id,
//           receiver_ids: [CONTROL_ROOM_USER_ID],
//           content: messageText,
//           attachment_urls: result.file_urls,
//           event_id: currentUser.event_id,
//           timestamp,
//           is_read: false,
//           tempId,
//         };

//         socketRef.current.emit('send_message', payload);

//         setMessageText('');
//         setAttachments([]);
//         setPreviewUrls([]);
//         if (fileInputRef.current) fileInputRef.current.value = '';
//         scrollToBottom();
//       } else {
//         setError('Failed to upload files: ' + result.error);
//         console.error('Failed to upload files:', result.error);
//       }
//     });

//     // Typing events
//     socket.on('user_typing', ({ user_id, is_typing }) => {
//       if (user_id === CONTROL_ROOM_USER_ID) {
//         setControlRoomTyping(is_typing);
//       }
//     });

//     return () => {
//       clearTimeout(typingTimeoutRef.current);
//       socket.disconnect();
//     };
//   }, [currentUser.id, currentUser.event_id]);

//   // Handle text input change
//   const handleTextChange = (e) => {
//     setMessageText(e.target.value);
//     handleTyping();
//   };

//   // Render message status icon
//   const renderMessageStatus = (msg) => {
//     if (msg.sender_id !== currentUser.id) return null;

//     switch (msg.status) {
//       case 'sending':
//         return <CircularProgress size={12} sx={{ ml: 1 }} />;
//       case 'failed':
//         return <CloseIcon color='error' sx={{ fontSize: 12, ml: 1 }} />;
//       case 'sent':
//         return msg.is_read ? (
//           <BiCheckDouble color='#4fc3f7' size={16} style={{ marginLeft: 4 }} />
//         ) : (
//           <BiCheck color='#9e9e9e' size={16} style={{ marginLeft: 4 }} />
//         );
//       default:
//         return null;
//     }
//   };

//   return (
//     <Paper
//       elevation={4}
//       sx={{
//         display: 'flex',
//         height: '85vh',
//         borderRadius: 3,
//         overflow: 'hidden',
//       }}
//     >
//       {/* Main Chat Area */}
//       <Box flex={1} display='flex' flexDirection='column' bgcolor='#f9fafb'>
//         {/* Header */}
//         <Box
//           py={2}
//           px={2}
//           borderBottom='1px solid #eee'
//           bgcolor='#fff'
//           display='flex'
//           alignItems='center'
//           gap={1}
//         >
//           <Avatar
//             sx={{ bgcolor: '#007bff', width: 32, height: 32, fontWeight: 600 }}
//           >
//             C
//           </Avatar>
//           <Box flex={1}>
//             <Typography variant='subtitle1' sx={{ fontWeight: 550 }}>
//               CONTROL ROOM - Event #{currentUser.event_id}
//             </Typography>
//             {controlRoomTyping && (
//               <Typography
//                 variant='caption'
//                 color='primary'
//                 sx={{ fontStyle: 'italic' }}
//               >
//                 Control Room is typing...
//               </Typography>
//             )}
//           </Box>

//           {unreadCount > 0 && (
//             <Chip
//               label={`${unreadCount} unread`}
//               color='primary'
//               size='small'
//               sx={{ mr: 1 }}
//             />
//           )}

//           <Box display='flex' alignItems='center' gap={1}>
//             <Chip
//               label={
//                 connected
//                   ? 'Connected'
//                   : reconnecting
//                   ? 'Reconnecting...'
//                   : 'Disconnected'
//               }
//               color={connected ? 'success' : reconnecting ? 'warning' : 'error'}
//               size='small'
//             />
//             {!connected && (
//               <Tooltip title='Reconnect'>
//                 <IconButton
//                   size='small'
//                   onClick={handleReconnect}
//                   disabled={reconnecting}
//                 >
//                   <RefreshIcon />
//                 </IconButton>
//               </Tooltip>
//             )}
//           </Box>
//         </Box>

//         {/* Messages Area */}
//         <Box flex={1} overflow='auto' p={2}>
//           {loading ? (
//             <Box display='flex' justifyContent='center' mt={5}>
//               <CircularProgress />
//               <Typography variant='body2' sx={{ ml: 2 }}>
//                 Loading messages...
//               </Typography>
//             </Box>
//           ) : messages.length === 0 ? (
//             <Box display='flex' justifyContent='center' mt={5}>
//               <Typography variant='body2' color='text.secondary'>
//                 No messages yet. Start chatting with Control Room!
//               </Typography>
//             </Box>
//           ) : (
//             messages.map((msg) => (
//               <Paper
//                 key={msg.id}
//                 elevation={1}
//                 sx={{
//                   mb: 2,
//                   p: 1.5,
//                   maxWidth: '75%',
//                   ml: msg.sender_id === currentUser.id ? 'auto' : 0,
//                   background:
//                     msg.sender_id === currentUser.id ? '#e3f2fd' : '#fff',
//                   borderLeft: `4px solid ${
//                     msg.sender_id === currentUser.id ? '#1976d2' : '#00acc1'
//                   }`,
//                   borderRadius: 2,
//                   cursor:
//                     !msg.is_read && msg.receiver_id === currentUser.id
//                       ? 'pointer'
//                       : 'default',
//                   opacity: msg.status === 'failed' ? 0.7 : 1,
//                 }}
//                 onClick={() =>
//                   !msg.is_read &&
//                   msg.receiver_id === currentUser.id &&
//                   handleMarkAsRead(msg.id)
//                 }
//               >
//                 {/* Message Header */}
//                 <Box display='flex' alignItems='center' mb={0.5}>
//                   <Avatar
//                     sx={{
//                       width: 25,
//                       height: 25,
//                       mr: 1,
//                       bgcolor:
//                         msg.sender_id !== currentUser.id
//                           ? '#00acc1'
//                           : '#1976d2',
//                       fontSize: '0.7rem',
//                       fontWeight: 550,
//                     }}
//                   >
//                     {msg.sender_id === currentUser.id
//                       ? currentUser.user_name?.[0]?.toUpperCase()
//                       : 'C'}
//                   </Avatar>
//                   <Typography variant='caption' sx={{ fontWeight: 600 }}>
//                     {msg.msg_sender}
//                   </Typography>
//                   <Typography
//                     variant='caption'
//                     color='text.secondary'
//                     sx={{ ml: 1 }}
//                   >
//                     {moment(msg.timestamp).format('hh:mm A')}
//                   </Typography>
//                   {renderMessageStatus(msg)}
//                 </Box>

//                 {/* Message Content */}
//                 {msg.content && (
//                   <Typography
//                     variant='body2'
//                     sx={{
//                       mb: msg.attachment_urls?.length > 0 ? 1 : 0,
//                       whiteSpace: 'pre-wrap',
//                     }}
//                   >
//                     {msg.content}
//                   </Typography>
//                 )}

//                 {/* Attachments */}
//                 {msg.attachment_urls?.length > 0 && (
//                   <Box display='flex' flexWrap='wrap' gap={1}>
//                     {msg.attachment_urls.map((url, i) => (
//                       <img
//                         key={i}
//                         src={url}
//                         alt='attachment'
//                         style={{
//                           maxWidth: 120,
//                           maxHeight: 120,
//                           borderRadius: 6,
//                           cursor: 'pointer',
//                           objectFit: 'cover',
//                         }}
//                         onClick={() => window.open(url, '_blank')}
//                       />
//                     ))}
//                   </Box>
//                 )}

//                 {/* Unread Indicator */}
//                 {!msg.is_read && msg.receiver_id === currentUser.id && (
//                   <Box mt={0.5}>
//                     <Chip
//                       label='New'
//                       color='primary'
//                       size='small'
//                       sx={{ height: 16, fontSize: '0.6rem' }}
//                     />
//                   </Box>
//                 )}
//               </Paper>
//             ))
//           )}
//           <div ref={chatEndRef} />
//         </Box>

//         {/* File Previews */}
//         {previewUrls.length > 0 && (
//           <Box p={2} bgcolor='#f1f8e9' borderTop='1px solid #eee'>
//             <Typography variant='caption' sx={{ mb: 1, display: 'block' }}>
//               Attachments ({previewUrls.length}):
//             </Typography>
//             <Box display='flex' flexWrap='wrap' gap={1}>
//               {previewUrls.map((url, i) => (
//                 <Box key={i} position='relative'>
//                   <img
//                     src={url}
//                     alt='preview'
//                     style={{
//                       width: 60,
//                       height: 60,
//                       borderRadius: 6,
//                       objectFit: 'cover',
//                     }}
//                   />
//                   <IconButton
//                     size='small'
//                     sx={{
//                       position: 'absolute',
//                       top: -8,
//                       right: -8,
//                       bgcolor: 'error.main',
//                       color: 'white',
//                       width: 20,
//                       height: 20,
//                       '&:hover': { bgcolor: 'error.dark' },
//                     }}
//                     onClick={() => removeAttachment(i)}
//                   >
//                     <CloseIcon sx={{ fontSize: 12 }} />
//                   </IconButton>
//                 </Box>
//               ))}
//             </Box>
//           </Box>
//         )}

//         {/* Message Input */}
//         <Box p={2} borderTop='1px solid #eee' bgcolor='#fff'>
//           <input
//             type='file'
//             multiple
//             accept='image/*'
//             ref={fileInputRef}
//             onChange={handleFileChange}
//             style={{ display: 'none' }}
//             id='ambulance-file-upload'
//           />

//           <form onSubmit={handleSendMessage}>
//             <TextField
//               fullWidth
//               multiline
//               minRows={2}
//               maxRows={4}
//               value={messageText}
//               onChange={handleTextChange}
//               placeholder='Type your message to Control Room...'
//               disabled={uploadingFiles || !connected}
//               InputProps={{
//                 endAdornment: (
//                   <>
//                     <InputAdornment position='end'>
//                       <label htmlFor='ambulance-file-upload'>
//                         <Tooltip title='Attach images'>
//                           <IconButton
//                             component='span'
//                             size='small'
//                             disabled={uploadingFiles || !connected}
//                           >
//                             <AttachFileIcon
//                               color={
//                                 uploadingFiles || !connected
//                                   ? 'disabled'
//                                   : 'primary'
//                               }
//                             />
//                           </IconButton>
//                         </Tooltip>
//                       </label>
//                     </InputAdornment>
//                     <InputAdornment position='end'>
//                       <Tooltip title='Send message'>
//                         <IconButton
//                           color='primary'
//                           type='submit'
//                           disabled={
//                             (!messageText.trim() && attachments.length === 0) ||
//                             uploadingFiles ||
//                             !connected
//                           }
//                           size='small'
//                         >
//                           {uploadingFiles ? (
//                             <CircularProgress size={20} />
//                           ) : (
//                             <SendIcon />
//                           )}
//                         </IconButton>
//                       </Tooltip>
//                     </InputAdornment>
//                   </>
//                 ),
//               }}
//             />
//           </form>
//         </Box>
//       </Box>

//       {/* Error Snackbar */}
//       <Snackbar
//         open={!!error}
//         autoHideDuration={6000}
//         onClose={() => setError('')}
//         anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
//       >
//         <Alert
//           onClose={() => setError('')}
//           severity='error'
//           sx={{ width: '100%' }}
//         >
//           {error}
//         </Alert>
//       </Snackbar>
//     </Paper>
//   );
// };

// export const ControlRoomChat = () => {
//   // Current user data from localStorage
//   const currentUser = {
//     id: parseInt(localStorage?.getItem('user_id')),
//     user_name: localStorage?.getItem('user_name'),
//     event_id: parseInt(localStorage?.getItem('event_id')),
//   };

//   // State management
//   const [users, setUsers] = useState([]);
//   const [selectedUsers, setSelectedUsers] = useState([]);
//   const [messages, setMessages] = useState([]);
//   const [messageText, setMessageText] = useState('');
//   const [attachments, setAttachments] = useState([]);
//   const [previewUrls, setPreviewUrls] = useState([]);
//   const [search, setSearch] = useState('');
//   const [loading, setLoading] = useState(false);
//   const [uploadingFiles, setUploadingFiles] = useState(false);
//   const [connected, setConnected] = useState(false);
//   const [reconnecting, setReconnecting] = useState(false);
//   const [totalUnreadCount, setTotalUnreadCount] = useState(0);
//   const [error, setError] = useState('');
//   const [typing, setTyping] = useState(false);
//   const [usersTyping, setUsersTyping] = useState(new Set());

//   // Refs
//   const fileInputRef = useRef();
//   const chatEndRef = useRef();
//   const socketRef = useRef();
//   const typingTimeoutRef = useRef();

//   // Constants
//   const MAX_FILE_SIZE = 10 * 1024 * 1024; // 10MB
//   const ALLOWED_FILE_TYPES = [
//     'image/jpeg',
//     'image/png',
//     'image/gif',
//     'image/webp',
//   ];

//   // Scroll to bottom function
//   const scrollToBottom = useCallback(() => {
//     setTimeout(() => {
//       chatEndRef.current?.scrollIntoView({ behavior: 'smooth' });
//     }, 100);
//   }, []);

//   // Calculate total unread count
//   const updateTotalUnreadCount = useCallback((usersList) => {
//     const total = usersList.reduce(
//       (sum, user) => sum + (user.unreadCount || 0),
//       0
//     );
//     setTotalUnreadCount(total);
//   }, []);

//   // File validation
//   const validateFiles = (files) => {
//     const errors = [];

//     files.forEach((file) => {
//       if (file.size > MAX_FILE_SIZE) {
//         errors.push(`${file.name} is too large (max 10MB)`);
//       }
//       if (!ALLOWED_FILE_TYPES.includes(file.type)) {
//         errors.push(`${file.name} is not a supported image format`);
//       }
//     });

//     return errors;
//   };

//   // Convert files to base64
//   const convertFilesToBase64 = (files) => {
//     return Promise.all(
//       files.map((file) => {
//         return new Promise((resolve, reject) => {
//           const reader = new FileReader();
//           reader.onload = () => {
//             resolve({
//               name: file.name,
//               type: file.type,
//               size: file.size,
//               data: reader.result.split(',')[1],
//             });
//           };
//           reader.onerror = reject;
//           reader.readAsDataURL(file);
//         });
//       })
//     );
//   };

//   // Typing indicator
//   const handleTyping = debounce(() => {
//     if (socketRef.current && connected && selectedUsers.length > 0) {
//       selectedUsers.forEach((userId) => {
//         socketRef.current.emit('typing', {
//           user_id: currentUser.id,
//           receiver_id: userId,
//           event_id: currentUser.event_id,
//           is_typing: true,
//         });
//       });

//       // Stop typing after 3 seconds
//       clearTimeout(typingTimeoutRef.current);
//       typingTimeoutRef.current = setTimeout(() => {
//         selectedUsers.forEach((userId) => {
//           socketRef.current.emit('typing', {
//             user_id: currentUser.id,
//             receiver_id: userId,
//             event_id: currentUser.event_id,
//             is_typing: false,
//           });
//         });
//       }, 3000);
//     }
//   }, 500);

//   // Send message function
//   const handleSendMessage = async (e) => {
//     if (e) e.preventDefault();
//     if (!messageText.trim() && attachments.length === 0) return;
//     if (selectedUsers.length === 0) {
//       setError('Please select at least one ambulance user');
//       return;
//     }
//     if (!socketRef.current || !connected) {
//       setError('Cannot send message: Not connected to server');
//       return;
//     }

//     let attachment_urls = [];

//     // Handle file uploads first
//     if (attachments.length > 0) {
//       const fileErrors = validateFiles(attachments);
//       if (fileErrors.length > 0) {
//         setError(fileErrors.join(', '));
//         return;
//       }

//       try {
//         setUploadingFiles(true);
//         const fileData = await convertFilesToBase64(attachments);

//         socketRef.current.emit('upload_files', {
//           files: fileData,
//           user_id: currentUser.id,
//           event_id: currentUser.event_id,
//         });
//         return;
//       } catch (error) {
//         setUploadingFiles(false);
//         setError('Failed to process files');
//         console.error('Failed to convert files:', error);
//         return;
//       }
//     }

//     // Create optimistic message
//     const tempId = `temp-${Date.now()}-${Math.random()}`;
//     const timestamp = new Date().toISOString();

//     const optimisticMessage = {
//       id: tempId,
//       sender_id: currentUser.id,
//       receiver_id: selectedUsers[0],
//       receiver_ids:
//         selectedUsers.length === 1 ? [selectedUsers[0]] : selectedUsers,
//       content: messageText,
//       attachment_urls,
//       event_id: currentUser.event_id,
//       timestamp,
//       is_read: false,
//       status: 'sending',
//     };

//     // Add optimistic message to UI
//     setMessages((prevMessages) => {
//       return uniqBy([...prevMessages, optimisticMessage], 'id');
//     });

//     // Prepare payload
//     const payload = {
//       sender_id: currentUser.id,
//       receiver_ids:
//         selectedUsers.length === 1 ? [selectedUsers[0]] : selectedUsers,
//       content: messageText,
//       attachment_urls,
//       event_id: currentUser.event_id,
//       timestamp,
//       is_read: false,
//       tempId,
//     };

//     // Send message via socket
//     socketRef.current.emit('send_message', payload);

//     // Clear inputs
//     setMessageText('');
//     setAttachments([]);
//     setPreviewUrls([]);
//     if (fileInputRef.current) fileInputRef.current.value = '';

//     // Stop typing indicator
//     selectedUsers.forEach((userId) => {
//       socketRef.current.emit('typing', {
//         user_id: currentUser.id,
//         receiver_id: userId,
//         event_id: currentUser.event_id,
//         is_typing: false,
//       });
//     });

//     scrollToBottom();
//   };

//   // Mark message as read
//   const handleMarkAsRead = (msgId, senderId) => {
//     if (!msgId) return;

//     setMessages((prev) =>
//       prev.map((m) => (m.id === msgId ? { ...m, is_read: true } : m))
//     );

//     if (senderId) {
//       setUsers((prev) => {
//         const updatedUsers = prev.map((u) =>
//           u.id === senderId ? { ...u, unreadCount: 0 } : u
//         );
//         updateTotalUnreadCount(updatedUsers);
//         return updatedUsers;
//       });
//     }

//     if (socketRef.current && connected) {
//       socketRef.current.emit('mark_message_read', {
//         message_id: msgId,
//         user_id: currentUser.id,
//         event_id: currentUser.event_id,
//       });
//     }
//   };

//   // File input handler
//   const handleFileChange = (e) => {
//     const files = Array.from(e.target.files);

//     const fileErrors = validateFiles(files);
//     if (fileErrors.length > 0) {
//       setError(fileErrors.join(', '));
//       return;
//     }

//     setAttachments(files);
//     const urls = files.map((file) => URL.createObjectURL(file));
//     setPreviewUrls(urls);
//   };

//   // Remove attachment
//   const removeAttachment = (index) => {
//     const newAttachments = attachments.filter((_, i) => i !== index);
//     const newPreviewUrls = previewUrls.filter((_, i) => i !== index);
//     setAttachments(newAttachments);
//     setPreviewUrls(newPreviewUrls);

//     if (newAttachments.length === 0 && fileInputRef.current) {
//       fileInputRef.current.value = '';
//     }
//   };

//   // Handle user selection
//   const handleUserSelection = (userId, isChecked) => {
//     if (isChecked) {
//       setSelectedUsers((prev) => [...prev, userId]);
//       // Clear unread count for selected user
//       setUsers((prev) => {
//         const updatedUsers = prev.map((u) =>
//           u.id === userId ? { ...u, unreadCount: 0 } : u
//         );
//         updateTotalUnreadCount(updatedUsers);
//         return updatedUsers;
//       });
//     } else {
//       setSelectedUsers((prev) => prev.filter((id) => id !== userId));
//     }
//   };

//   // Handle select all
//   const handleSelectAll = (isChecked) => {
//     if (isChecked) {
//       setSelectedUsers(users.map((u) => u.id));
//       // Clear all unread counts
//       setUsers((prev) => {
//         const updatedUsers = prev.map((u) => ({ ...u, unreadCount: 0 }));
//         updateTotalUnreadCount(updatedUsers);
//         return updatedUsers;
//       });
//     } else {
//       setSelectedUsers([]);
//     }
//   };

//   // Reconnect function
//   const handleReconnect = () => {
//     if (socketRef.current) {
//       setReconnecting(true);
//       socketRef.current.disconnect();
//       socketRef.current.connect();
//     }
//   };

//   // Socket connection effect
//   useEffect(() => {
//     const socket = io(WS_URL, {
//       transports: ['websocket'],
//       reconnection: true,
//       reconnectionDelay: 1000,
//       reconnectionAttempts: 5,
//       timeout: 20000,
//       forceNew: true,
//     });

//     socketRef.current = socket;

//     // Connection events
//     socket.on('connect', () => {
//       console.log('Control Room Socket connected');
//       setConnected(true);
//       setReconnecting(false);
//       setError('');

//       // Join control room specific channel
//       socket.emit('join', {
//         user_id: currentUser.id,
//         event_id: currentUser.event_id,
//       });

//       // Get ambulance users
//       socket.emit('get_users_by_role', {
//         role: 'ambulance',
//         event_id: currentUser.event_id,
//       });
//     });

//     socket.on('reconnect', (attemptNumber) => {
//       console.log(
//         'Control Room Socket reconnected after',
//         attemptNumber,
//         'attempts'
//       );
//       setConnected(true);
//       setReconnecting(false);
//       setError('');
//     });

//     socket.on('disconnect', (reason) => {
//       console.log('Control Room Socket disconnected:', reason);
//       setConnected(false);
//       if (reason === 'io server disconnect') {
//         socket.connect();
//       }
//     });

//     socket.on('connect_error', (error) => {
//       console.error('Connection error:', error);
//       setError('Connection failed. Please check your internet connection.');
//     });

//     // Message events
//     socket.on('get_all_messages_result', (msgs) => {
//       console.log('Control Room - Fetched messages:', msgs);

//       // Filter messages for control room conversations with selected users
//       const filteredMessages = msgs.filter((msg) => {
//         return (
//           msg.event_id === currentUser.event_id &&
//           ((msg.sender_id === currentUser.id &&
//             selectedUsers.includes(msg.receiver_id)) ||
//             (msg.receiver_id === currentUser.id &&
//               selectedUsers.includes(msg.sender_id)) ||
//             (Array.isArray(msg.receiver_ids) &&
//               msg.receiver_ids.some((id) => selectedUsers.includes(id))))
//         );
//       });

//       setMessages(reverse(msgs));
//       setLoading(false);
//       scrollToBottom();
//     });

//     socket.on('send_message_result', (result) => {
//       if (result.success) {
//         setMessages((prevMessages) =>
//           prevMessages.map((msg) =>
//             msg.status === 'sending' && msg.id === result.tempId
//               ? { ...msg, status: 'sent', id: result.message_id || msg.id }
//               : msg
//           )
//         );
//       } else {
//         console.error('Failed to send message:', result.error);
//         setError('Failed to send message: ' + result.error);
//         setMessages((prevMessages) =>
//           prevMessages.map((msg) =>
//             msg.status === 'sending' ? { ...msg, status: 'failed' } : msg
//           )
//         );
//       }
//     });

//     socket.on('new_message', (msg) => {
//       console.log('Control Room - Received new message:', msg);

//       // Filter for control room conversations
//       const shouldShowMessage =
//         msg.event_id === currentUser.event_id &&
//         selectedUsers.length > 0 &&
//         ((msg.sender_id === currentUser.id &&
//           selectedUsers.includes(msg.receiver_id)) ||
//           (msg.receiver_id === currentUser.id &&
//             selectedUsers.includes(msg.sender_id)) ||
//           (Array.isArray(msg.receiver_ids) &&
//             msg.receiver_ids.includes(currentUser.id)));

//       if (shouldShowMessage) {
//         setMessages((prev) => {
//           const isDuplicate = prev.some(
//             (existingMsg) =>
//               existingMsg.id === msg.id ||
//               (existingMsg.sender_id === msg.sender_id &&
//                 existingMsg.content === msg.content &&
//                 Math.abs(
//                   new Date(existingMsg.timestamp) - new Date(msg.timestamp)
//                 ) < 1000)
//           );

//           if (!isDuplicate) {
//             return uniqBy([...prev, msg], 'id');
//           }
//           return prev;
//         });
//         scrollToBottom();
//       }

//       // Update unread count for messages from ambulance users
//       if (
//         msg.receiver_id === currentUser.id &&
//         msg.sender_id !== currentUser.id
//       ) {
//         setUsers((prevUsers) => {
//           const updatedUsers = prevUsers.map((u) => {
//             if (u.id === msg.sender_id) {
//               const isCurrentlySelected = selectedUsers.includes(msg.sender_id);
//               const newUnreadCount = isCurrentlySelected
//                 ? u.unreadCount || 0
//                 : (u.unreadCount || 0) + 1;

//               return { ...u, unreadCount: newUnreadCount };
//             }
//             return u;
//           });

//           updateTotalUnreadCount(updatedUsers);
//           return updatedUsers;
//         });
//       }
//     });

//     socket.on('message_read', ({ msg_id, read_by }) => {
//       setMessages((prev) =>
//         prev.map((m) => (m.id === msg_id ? { ...m, is_read: true } : m))
//       );
//     });

//     socket.on('message_read_confirmation', ({ message_id, read_by }) => {
//       setMessages((prev) =>
//         prev.map((m) => (m.id === message_id ? { ...m, is_read: true } : m))
//       );
//     });

//     // User events
//     socket.on('get_users_by_role_result', (fetchedUsers) => {
//       console.log('Control Room - Fetched ambulance users:', fetchedUsers);
//       const usersWithUnread = fetchedUsers.map((user) => ({
//         ...user,
//         unreadCount: 0,
//       }));
//       setUsers(usersWithUnread);
//       updateTotalUnreadCount(usersWithUnread);
//     });

//     // File upload events
//     socket.on('upload_files_result', (result) => {
//       setUploadingFiles(false);

//       if (result.success) {
//         const tempId = `temp-${Date.now()}-${Math.random()}`;
//         const timestamp = new Date().toISOString();

//         const optimisticMessage = {
//           id: tempId,
//           sender_id: currentUser.id,
//           receiver_id: selectedUsers[0],
//           receiver_ids:
//             selectedUsers.length === 1 ? [selectedUsers[0]] : selectedUsers,
//           content: messageText,
//           attachment_urls: result.file_urls,
//           event_id: currentUser.event_id,
//           timestamp,
//           is_read: false,
//           status: 'sending',
//         };

//         setMessages((prevMessages) => {
//           return uniqBy([...prevMessages, optimisticMessage], 'id');
//         });

//         const payload = {
//           sender_id: currentUser.id,
//           receiver_ids:
//             selectedUsers.length === 1 ? [selectedUsers[0]] : selectedUsers,
//           content: messageText,
//           attachment_urls: result.file_urls,
//           event_id: currentUser.event_id,
//           timestamp,
//           is_read: false,
//           tempId,
//         };

//         socketRef.current.emit('send_message', payload);

//         setMessageText('');
//         setAttachments([]);
//         setPreviewUrls([]);
//         if (fileInputRef.current) fileInputRef.current.value = '';
//         scrollToBottom();
//       } else {
//         setError('Failed to upload files: ' + result.error);
//         console.error('Failed to upload files:', result.error);
//       }
//     });

//     // Typing events
//     socket.on('user_typing', ({ user_id, is_typing }) => {
//       setUsersTyping((prev) => {
//         const newSet = new Set(prev);
//         if (is_typing) {
//           newSet.add(user_id);
//         } else {
//           newSet.delete(user_id);
//         }
//         return newSet;
//       });
//     });

//     return () => {
//       clearTimeout(typingTimeoutRef.current);
//       socket.disconnect();
//     };
//   }, [currentUser.id, currentUser.event_id]);

//   // Fetch messages when selected users change
//   useEffect(() => {
//     if (!isEmpty(selectedUsers) && socketRef.current && connected) {
//       setLoading(true);
//       setMessages([]);

//       if (selectedUsers.length === 1) {
//         socketRef.current.emit('get_all_messages', {
//           event_id: currentUser.event_id,
//           user_id: selectedUsers[0],
//           receiver_id: selectedUsers,
//           sender_id: selectedUsers[0],
//         });
//       } else {
//         // For multiple users, we need to handle group conversation
//         selectedUsers.forEach((userId, index) => {
//           setTimeout(() => {
//             socketRef.current.emit('get_all_messages', {
//               event_id: currentUser.event_id,
//               user_id: selectedUsers[0],
//               receiver_id: selectedUsers,
//               sender_id: selectedUsers[0],
//             });
//           }, index * 100);
//         });
//       }
//     } else {
//       setMessages([]);
//       setLoading(false);
//     }
//   }, [selectedUsers, connected]);

//   // Handle text input change
//   const handleTextChange = (e) => {
//     setMessageText(e.target.value);
//     handleTyping();
//   };

//   // Render message status icon
//   const renderMessageStatus = (msg) => {
//     if (msg.sender_id !== currentUser.id) return null;

//     switch (msg.status) {
//       case 'sending':
//         return <CircularProgress size={12} sx={{ ml: 1 }} />;
//       case 'failed':
//         return <CloseIcon color='error' sx={{ fontSize: 12, ml: 1 }} />;
//       case 'sent':
//         return msg.is_read ? (
//           <BiCheckDouble color='#4fc3f7' size={16} style={{ marginLeft: 4 }} />
//         ) : (
//           <BiCheck color='#9e9e9e' size={16} style={{ marginLeft: 4 }} />
//         );
//       default:
//         return null;
//     }
//   };

//   // Get typing users display
//   const getTypingDisplay = () => {
//     const typingUsersList = Array.from(usersTyping)
//       .filter((userId) => selectedUsers.includes(userId))
//       .map((userId) => {
//         const user = users.find((u) => u.id === userId);
//         return user?.username || 'Ambulance User';
//       });

//     if (typingUsersList.length === 0) return null;

//     if (typingUsersList.length === 1) {
//       return `${typingUsersList[0]} is typing...`;
//     } else if (typingUsersList.length === 2) {
//       return `${typingUsersList[0]} and ${typingUsersList[1]} are typing...`;
//     } else {
//       return `${typingUsersList.length} users are typing...`;
//     }
//   };

//   const filteredUsers = users.filter(
//     (u) =>
//       u.username?.toLowerCase().includes(search.toLowerCase()) ||
//       u.phone?.includes(search)
//   );

//   return (
//     <Paper
//       elevation={4}
//       sx={{
//         display: 'flex',
//         height: '85vh',
//         borderRadius: 3,
//         overflow: 'hidden',
//       }}
//     >
//       {/* Sidebar */}
//       <Box
//         width={{ md: 320, sm: 250 }}
//         display='flex'
//         flexDirection='column'
//         bgcolor='#f7f9fc'
//         borderRight='1px solid #e0e0e0'
//       >
//         {/* Sidebar Header */}
//         <Box p={2} pb={0}>
//           <Box
//             display='flex'
//             alignItems='center'
//             justifyContent='space-between'
//           >
//             <Typography variant='h6' sx={{ fontWeight: 600 }}>
//               Ambulance Users
//             </Typography>
//             {totalUnreadCount > 0 && (
//               <Badge badgeContent={totalUnreadCount} color='error' max={99}>
//                 <Typography variant='caption' color='text.secondary'>
//                   Unread
//                 </Typography>
//               </Badge>
//             )}
//           </Box>

//           {/* Search */}
//           <TextField
//             size='small'
//             placeholder='Search ambulance users...'
//             value={search}
//             onChange={(e) => setSearch(e.target.value)}
//             InputProps={{
//               startAdornment: (
//                 <InputAdornment position='start'>
//                   <SearchIcon color='action' />
//                 </InputAdornment>
//               ),
//             }}
//             sx={{ mt: 1, mb: 1.5, width: '100%' }}
//           />

//           {/* Select All */}
//           <FormControlLabel
//             sx={{ mb: 1 }}
//             control={
//               <Checkbox
//                 checked={
//                   selectedUsers.length === users.length && users.length > 0
//                 }
//                 indeterminate={
//                   selectedUsers.length > 0 &&
//                   selectedUsers.length < users.length
//                 }
//                 onChange={(e) => handleSelectAll(e.target.checked)}
//               />
//             }
//             label={
//               <Box display='flex' alignItems='center'>
//                 <BroadcastIcon sx={{ mr: 0.5, fontSize: 16 }} />
//                 Broadcast All
//               </Box>
//             }
//           />

//           {selectedUsers.length > 0 && (
//             <Chip
//               label={`${selectedUsers.length} selected`}
//               color='primary'
//               size='small'
//               sx={{ mb: 1 }}
//             />
//           )}
//         </Box>

//         <Divider />

//         {/* Users List */}
//         <List dense sx={{ flex: 1, overflow: 'auto', px: 1 }}>
//           {filteredUsers.length === 0 ? (
//             <Box p={2} textAlign='center'>
//               <Typography variant='body2' color='text.secondary'>
//                 No ambulance users found
//               </Typography>
//             </Box>
//           ) : (
//             filteredUsers.map((u) => (
//               <ListItem
//                 key={u.id}
//                 disablePadding
//                 sx={{
//                   '&:hover': { bgcolor: '#eef3fb' },
//                   borderRadius: 1,
//                   px: 1,
//                   bgcolor: selectedUsers.includes(u.id)
//                     ? '#e3f2fd'
//                     : 'transparent',
//                 }}
//               >
//                 <FormControlLabel
//                   sx={{ width: '100%', px: 1 }}
//                   control={
//                     <Checkbox
//                       checked={selectedUsers.includes(u.id)}
//                       onChange={(e) =>
//                         handleUserSelection(u.id, e.target.checked)
//                       }
//                     />
//                   }
//                   label={
//                     <Box
//                       display='flex'
//                       justifyContent='space-between'
//                       alignItems='center'
//                       width='100%'
//                     >
//                       <Box>
//                         <Typography variant='body2' sx={{ fontWeight: 500 }}>
//                           {u.username}
//                         </Typography>
//                         <Typography variant='caption' color='text.secondary'>
//                           {u.phone}
//                         </Typography>
//                       </Box>
//                       {u.unreadCount > 0 && (
//                         <Badge
//                           badgeContent={u.unreadCount}
//                           color='error'
//                           max={99}
//                         />
//                       )}
//                     </Box>
//                   }
//                 />
//               </ListItem>
//             ))
//           )}
//         </List>
//       </Box>

//       {/* Main Chat Area */}
//       <Box flex={1} display='flex' flexDirection='column' bgcolor='#f9fafb'>
//         {/* Header */}
//         <Box
//           py={2}
//           px={2}
//           borderBottom='1px solid #eee'
//           bgcolor='#fff'
//           display='flex'
//           alignItems='center'
//           gap={1}
//         >
//           <Avatar
//             sx={{ bgcolor: '#007bff', width: 32, height: 32, fontWeight: 600 }}
//           >
//             C
//           </Avatar>
//           <Box flex={1}>
//             <Typography variant='subtitle1' sx={{ fontWeight: 550 }}>
//               CONTROL ROOM - Event #{currentUser.event_id}
//               {selectedUsers.length > 0 && (
//                 <Typography
//                   component='span'
//                   variant='caption'
//                   sx={{ ml: 1, color: 'text.secondary' }}
//                 >
//                   ({selectedUsers.length} selected)
//                 </Typography>
//               )}
//             </Typography>
//             {getTypingDisplay() && (
//               <Typography
//                 variant='caption'
//                 color='primary'
//                 sx={{ fontStyle: 'italic' }}
//               >
//                 {getTypingDisplay()}
//               </Typography>
//             )}
//           </Box>

//           <Box display='flex' alignItems='center' gap={1}>
//             <Chip
//               label={
//                 connected
//                   ? 'Connected'
//                   : reconnecting
//                   ? 'Reconnecting...'
//                   : 'Disconnected'
//               }
//               color={connected ? 'success' : reconnecting ? 'warning' : 'error'}
//               size='small'
//             />
//             {!connected && (
//               <Tooltip title='Reconnect'>
//                 <IconButton
//                   size='small'
//                   onClick={handleReconnect}
//                   disabled={reconnecting}
//                 >
//                   <RefreshIcon />
//                 </IconButton>
//               </Tooltip>
//             )}
//           </Box>
//         </Box>

//         {/* Messages Area */}
//         <Box flex={1} overflow='auto' p={2}>
//           {loading ? (
//             <Box display='flex' justifyContent='center' mt={5}>
//               <CircularProgress />
//               <Typography variant='body2' sx={{ ml: 2 }}>
//                 Loading messages...
//               </Typography>
//             </Box>
//           ) : messages.length === 0 ? (
//             <Box display='flex' justifyContent='center' mt={5}>
//               <Typography variant='body2' color='text.secondary'>
//                 {selectedUsers.length === 0
//                   ? 'Select ambulance users to start chatting'
//                   : 'No messages yet. Start the conversation!'}
//               </Typography>
//             </Box>
//           ) : (
//             messages.map((msg) => (
//               <Paper
//                 key={msg.id}
//                 elevation={1}
//                 sx={{
//                   mb: 2,
//                   p: 1.5,
//                   maxWidth: '75%',
//                   ml: msg.sender_id === currentUser.id ? 'auto' : 0,
//                   background:
//                     msg.sender_id === currentUser.id ? '#e3f2fd' : '#fff',
//                   borderLeft: `4px solid ${
//                     msg.sender_id === currentUser.id ? '#1976d2' : '#00acc1'
//                   }`,
//                   borderRadius: 2,
//                   cursor:
//                     !msg.is_read && msg.receiver_id === currentUser.id
//                       ? 'pointer'
//                       : 'default',
//                   opacity: msg.status === 'failed' ? 0.7 : 1,
//                 }}
//                 onClick={() =>
//                   !msg.is_read &&
//                   msg.receiver_id === currentUser.id &&
//                   handleMarkAsRead(msg.id, msg.sender_id)
//                 }
//               >
//                 {/* Message Header */}
//                 <Box display='flex' alignItems='center' mb={0.5}>
//                   <Avatar
//                     sx={{
//                       width: 25,
//                       height: 25,
//                       mr: 1,
//                       bgcolor:
//                         msg.sender_id !== currentUser.id
//                           ? '#00acc1'
//                           : '#1976d2',
//                       fontSize: '0.7rem',
//                       fontWeight: 550,
//                     }}
//                   >
//                     {msg.sender_id === currentUser.id
//                       ? currentUser.user_name?.[0]?.toUpperCase()
//                       : users
//                           .find((u) => u.id === msg.sender_id)
//                           ?.username?.[0]?.toUpperCase() || 'A'}
//                   </Avatar>
//                   <Typography variant='caption' sx={{ fontWeight: 600 }}>
//                     {msg.sender_id === currentUser.id
//                       ? 'You'
//                       : users.find((u) => u.id === msg.sender_id)?.username ||
//                         'Ambulance User'}
//                   </Typography>
//                   <Typography
//                     variant='caption'
//                     color='text.secondary'
//                     sx={{ ml: 1 }}
//                   >
//                     {moment(msg.timestamp).format('hh:mm A')}
//                   </Typography>
//                   {renderMessageStatus(msg)}
//                 </Box>

//                 {/* Message Content */}
//                 {msg.content && (
//                   <Typography
//                     variant='body2'
//                     sx={{
//                       mb: msg.attachment_urls?.length > 0 ? 1 : 0,
//                       whiteSpace: 'pre-wrap',
//                     }}
//                   >
//                     {msg.content}
//                   </Typography>
//                 )}

//                 {/* Attachments */}
//                 {msg.attachment_urls?.length > 0 && (
//                   <Box display='flex' flexWrap='wrap' gap={1}>
//                     {msg.attachment_urls.map((url, i) => (
//                       <img
//                         key={i}
//                         src={url}
//                         alt='attachment'
//                         style={{
//                           maxWidth: 120,
//                           maxHeight: 120,
//                           borderRadius: 6,
//                           cursor: 'pointer',
//                           objectFit: 'cover',
//                         }}
//                         onClick={() => window.open(url, '_blank')}
//                       />
//                     ))}
//                   </Box>
//                 )}

//                 {/* Broadcast indicator */}
//                 {Array.isArray(msg.receiver_ids) &&
//                   msg.receiver_ids.length > 1 &&
//                   msg.sender_id === currentUser.id && (
//                     <Box mt={0.5}>
//                       <Chip
//                         icon={<BroadcastIcon sx={{ fontSize: 12 }} />}
//                         label={`Broadcast to ${msg.receiver_ids.length} users`}
//                         color='primary'
//                         size='small'
//                         sx={{ height: 20, fontSize: '0.7rem' }}
//                       />
//                     </Box>
//                   )}
//               </Paper>
//             ))
//           )}
//           <div ref={chatEndRef} />
//         </Box>

//         {/* File Previews */}
//         {previewUrls.length > 0 && (
//           <Box p={2} bgcolor='#f1f8e9' borderTop='1px solid #eee'>
//             <Typography variant='caption' sx={{ mb: 1, display: 'block' }}>
//               Attachments ({previewUrls.length}):
//             </Typography>
//             <Box display='flex' flexWrap='wrap' gap={1}>
//               {previewUrls.map((url, i) => (
//                 <Box key={i} position='relative'>
//                   <img
//                     src={url}
//                     alt='preview'
//                     style={{
//                       width: 60,
//                       height: 60,
//                       borderRadius: 6,
//                       objectFit: 'cover',
//                     }}
//                   />
//                   <IconButton
//                     size='small'
//                     sx={{
//                       position: 'absolute',
//                       top: -8,
//                       right: -8,
//                       bgcolor: 'error.main',
//                       color: 'white',
//                       width: 20,
//                       height: 20,
//                       '&:hover': { bgcolor: 'error.dark' },
//                     }}
//                     onClick={() => removeAttachment(i)}
//                   >
//                     <CloseIcon sx={{ fontSize: 12 }} />
//                   </IconButton>
//                 </Box>
//               ))}
//             </Box>
//           </Box>
//         )}

//         {/* Message Input */}
//         <Box p={2} borderTop='1px solid #eee' bgcolor='#fff'>
//           <input
//             type='file'
//             multiple
//             accept='image/*'
//             ref={fileInputRef}
//             onChange={handleFileChange}
//             style={{ display: 'none' }}
//             id='control-room-file-upload'
//           />

//           <form onSubmit={handleSendMessage}>
//             <TextField
//               fullWidth
//               multiline
//               minRows={2}
//               maxRows={4}
//               value={messageText}
//               onChange={handleTextChange}
//               placeholder={
//                 selectedUsers.length === 0
//                   ? 'Select ambulance users to send message...'
//                   : selectedUsers.length === 1
//                   ? 'Type your message...'
//                   : `Broadcasting to ${selectedUsers.length} users...`
//               }
//               disabled={
//                 uploadingFiles || !connected || selectedUsers.length === 0
//               }
//               InputProps={{
//                 endAdornment: (
//                   <>
//                     <InputAdornment position='end'>
//                       <label htmlFor='control-room-file-upload'>
//                         <Tooltip title='Attach images'>
//                           <IconButton
//                             component='span'
//                             size='small'
//                             disabled={
//                               uploadingFiles ||
//                               !connected ||
//                               selectedUsers.length === 0
//                             }
//                           >
//                             <AttachFileIcon
//                               color={
//                                 uploadingFiles ||
//                                 !connected ||
//                                 selectedUsers.length === 0
//                                   ? 'disabled'
//                                   : 'primary'
//                               }
//                             />
//                           </IconButton>
//                         </Tooltip>
//                       </label>
//                     </InputAdornment>
//                     <InputAdornment position='end'>
//                       <Tooltip title='Send message'>
//                         <IconButton
//                           color='primary'
//                           type='submit'
//                           disabled={
//                             (!messageText.trim() && attachments.length === 0) ||
//                             uploadingFiles ||
//                             !connected ||
//                             selectedUsers.length === 0
//                           }
//                           size='small'
//                         >
//                           {uploadingFiles ? (
//                             <CircularProgress size={20} />
//                           ) : selectedUsers.length > 1 ? (
//                             <BroadcastIcon />
//                           ) : (
//                             <SendIcon />
//                           )}
//                         </IconButton>
//                       </Tooltip>
//                     </InputAdornment>
//                   </>
//                 ),
//               }}
//             />
//           </form>
//         </Box>
//       </Box>

//       {/* Error Snackbar */}
//       <Snackbar
//         open={!!error}
//         autoHideDuration={6000}
//         onClose={() => setError('')}
//         anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
//       >
//         <Alert
//           onClose={() => setError('')}
//           severity='error'
//           sx={{ width: '100%' }}
//         >
//           {error}
//         </Alert>
//       </Snackbar>
//     </Paper>
//   );
// };

// ChatComponent.jsx
import React, { useEffect, useState } from 'react';
import { io } from 'socket.io-client';
import axios from 'axios';

const SOCKET_URL = process.env.REACT_APP_SOCKET_URL;
const API_URL = `${process.env.REACT_APP_API_URL}/messages`;

export default function ChatComponent() {
  const selectedUsers = [126];
  const currentUser = {
    id: parseInt(localStorage?.getItem('user_id')),
    user_name: localStorage?.getItem('user_name'),
    event_id: parseInt(localStorage?.getItem('event_id')),
  };

  const [socket, setSocket] = useState(null);
  const [messages, setMessages] = useState([]);
  const [text, setText] = useState('');

  // connect once
  useEffect(() => {
    if (!currentUser?.id) return;

    const s = io(SOCKET_URL, {
      transports: ['websocket'],
    });

    s.on('connect', () => console.log('Socket connected', s.id));
    s.on('connect_error', (err) => console.error('Socket connect error', err));

    setSocket(s);

    return () => {
      s.disconnect();
    };
  }, [currentUser?.id]);

  // join & listen
  useEffect(() => {
    if (!socket || !currentUser?.id) return;

    socket.emit('join', { user_id: currentUser.id });

    const handleNewMessage = (msg) => {
      console.log('New message received', msg);
      if (
        msg.receivers?.includes(currentUser.id) ||
        msg.sender_id === currentUser.id
      ) {
        setMessages((prev) => [...prev, msg]);
      }
    };

    socket.on('new_message', handleNewMessage);

    return () => {
      socket.off('new_message', handleNewMessage);
      socket.emit('leave', { user_id: currentUser.id });
    };
  }, [socket, currentUser?.id]);

  // initial load
  useEffect(() => {
    if (!currentUser?.id) return;
    axios
      .get(`${API_URL}/messages/${currentUser?.event_id}/sc/${currentUser.id}`)
      .then((res) => setMessages(res.data))
      .catch((err) => console.error(err));
  }, [currentUser?.id]);

  const sendMessage = async () => {
    if (!text.trim() || selectedUsers?.length === 0) return;

    await axios.post(`${API_URL}/sendmessage/${currentUser.event_id}`, {
      sender_id: currentUser.id,
      receivers: selectedUsers, // adjust field name!
      content: text,
    });

    setText('');
  };

  return (
    <div className='p-4'>
      <div className='flex gap-2 mt-2'>
        <input
          className='border flex-1 p-1'
          value={text}
          onChange={(e) => setText(e.target.value)}
          placeholder='Type message...'
        />
        <button onClick={sendMessage} className='bg-blue-500 text-white px-3'>
          Send
        </button>
      </div>
      <div className='h-64 overflow-y-auto border p-2'>
        {messages.map((m, idx) => (
          <div key={m.id || idx} className='mb-2'>
            <strong>
              {m.sender_id === currentUser.id ? 'Me' : m.sender_id}:
            </strong>{' '}
            {m.content}
          </div>
        ))}
      </div>
    </div>
  );
}
